import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/cattoire/data/git/instana-humio-hybrid-systemZ/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">2-1: Getting Started</AnchorLink>
  <AnchorLink mdxType="AnchorLink">2-2: Analyzing zHybridApp</AnchorLink>
  <AnchorLink mdxType="AnchorLink">2-3: Problem Analysis Using IBM Instana for z/OS</AnchorLink>
  <AnchorLink mdxType="AnchorLink">2-4: Understanding Dependencies Using IBM Instana for z/OS</AnchorLink>
  <AnchorLink mdxType="AnchorLink">2-5: Summary</AnchorLink>
    </AnchorLinks>
    <hr></hr>
    <p>{`IBM Observability by Instana APM for z/OS (Instana for z/OS) provides transaction tracing information and resource monitoring metrics from z/OS subsystems to Instana, IBM’s APM/Observability solution.  Instana for z/OS can be implemented on z/OS purely as a feed to Instana for transaction tracing data of key z/OS subsystems, or may be combined with existing OMEGAMON z/OS system monitoring to provide additional resource monitoring and metrics for z/OS subsystems.
The objective of this set of lab exercises is to introduce the capabilities of IBM Instana for z/OS, and to demonstrate the ability of Instana for z/OS to highlight and identify z/OS transaction issues in an end to end manner.`}<br parentName="p"></br>{`
`}{`The lab environment is running in a live z/OS environment and is passing information to a live Instana server. `}</p>
    <h2>{`2-1: Getting Started`}</h2>
    <p>{`Begin by logging into the Soleil lab environment.  You should see a picture of a desktop system.  Click on the system to login.
After logging in, launch the Chrome browser. The browser will open with 3 tabs`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "69.44444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAABYlAAAWJQFJUiTwAAAC+UlEQVQ4y52T22vbZRjHf/Wwm14Ug7g2B5qmrWlT8WJ4M+/8R7wT9EKmUmeTFssUJoOhFzJRdmjSJqngrMOBs02Tpm5uTrZF2rF2PeR3Puectpt48ZH8Kswrwb3w4ft9br7v87y8jzC/vE06r5HOq6RyCqklmVROZi6vc+HqBvHPzjN15qLHqc9n+XD6C95PnGH6bJLxT87xwfSXnPz0HF999zvZoonwzaJEpqCRyaus79YQjSZbcpUHcpU7D03uiw0eKG3WxTpr5Rrr5RpruxXuS002tX02lDabaosb6xazOQUhmRNJFzSyBZWNsoZjaWiaiqoqiJKIWN5Flsqoquxh6JqHpinomoIsSxiaxEPRIpVTETqdZQo6qcUyr73+BqFggFhsjEhkEL/fTyAQ8PD7A/g99f/DoQ8EQxx96UXeHZ/m8q0aQuftMis6yZ93CYajCILwVLz51gkWbjcQZpdEsis6M9d2iL5yjL7eo/T1+QmFQvT29jIwMEBPT49Xd3wwGKS/v59wOIzP56Or6xkv8O0TcRZ+ayB8/f0a2aLBpWvbvHrsOJGBMLGxMQYHB4lGo0QiEUZGRhgeHmZoaMjT0dFRYrGYd8HzR454ge+8lzgMnLtyi/miSfKnHQL9L/Pcs1284PPR3d39v0f+4XYTIX31JtkVg/O5MqdOn2UyEWdqaorJyUni8TgTExP/STyR4KOT46S+/ZH5VRvhyuUbpFcMPl4o4bT3edqjVw6YWZQR5pY10gWV9KLIVln3/pwoShimgWmaWJaF4zjYjo1t215dcSs0Gg3q9Tq1Wp29VoMt2SW5pCBkOmF5lfmizo5soesaqqohywqSLGMYJo7j4rgurlvxtFKt0mq1abXbNFttHh3ssa1U/x14uCmq4VJ1DGzLwLEMXNvEsXRc26Bec2nWq57uter8+Xjf4/GjffjrAMmoMbMkP+mws8+rJY1f/1C4XpK5XpKecE/il3uHfvWuyM01lTubDnc3HU9LWw7FksnsssrfUBYQNXKaTwUAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "browsertab",
        "title": "browsertab",
        "src": "/instana-humio-hybrid-systemZ/static/b3ad67ec115cc4d178a2408a257b78a0/3cbba/browsertab.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/b3ad67ec115cc4d178a2408a257b78a0/7fc1e/browsertab.png 288w", "/instana-humio-hybrid-systemZ/static/b3ad67ec115cc4d178a2408a257b78a0/a5df1/browsertab.png 576w", "/instana-humio-hybrid-systemZ/static/b3ad67ec115cc4d178a2408a257b78a0/3cbba/browsertab.png 1152w", "/instana-humio-hybrid-systemZ/static/b3ad67ec115cc4d178a2408a257b78a0/0b124/browsertab.png 1728w", "/instana-humio-hybrid-systemZ/static/b3ad67ec115cc4d178a2408a257b78a0/4ea69/browsertab.png 2304w", "/instana-humio-hybrid-systemZ/static/b3ad67ec115cc4d178a2408a257b78a0/b3e5a/browsertab.png 2678w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <ul>
      <li parentName="ul">{`The first tab is the lab guide.  `}</li>
      <li parentName="ul">{`The 2nd tab is the Instana user interface`}</li>
      <li parentName="ul">{`The 3rd tab is a file that contains the username and password that you will use to login to Instana`}</li>
    </ul>
    <p>{`Use the username and password from the 3rd tab to login to the Instana user interface.
You should now be looking at the home panel for Instana.  The focus of these lab exercises will be on the monitoring information in the ‘Applications’ portion of the display.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "46.18055555555556%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAAAsTAAALEwEAmpwYAAABLElEQVQoz42S20rEMBCG+4h6ISjoncLiLsr6oPsk3W1znMnk8Muk9cIixcLPBEq+fJnJ8Hz4RLlckIlQWkMpBaXW3dRNjHUYbzOu04zh6XiG9x6zMfA+LMBS17pNBeUMlwSOEygJSCsnjJOBi4Th8fiFyATr/GJQ9qNGUQqMJ1gWTNaDiHGdbT9geDmdEZgWu1qRS9mNmrIU2EDwnDuQf2wV+HD4gH5J5E+bJBmBZYGtN9C15AzRKrmvFRY5Ybh7fQdRhA/hXwPJpSIoIC8gBfJq14H3b6f+w/nQjfZ6ZyjDRIZjgYsMG1Pfp7f7BWRJffS6UXJB3mbt3RgEo42YQsLkIm6eYLSHW8PewySora1vqy3Rd1krpFS01uBTgWfpU45JEFLudnqgwhT4DbLKsdZ6kUEaAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana",
        "title": "Instana",
        "src": "/instana-humio-hybrid-systemZ/static/7d51529bfec5170b1ba916f4285a583c/3cbba/Instana.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/7d51529bfec5170b1ba916f4285a583c/7fc1e/Instana.png 288w", "/instana-humio-hybrid-systemZ/static/7d51529bfec5170b1ba916f4285a583c/a5df1/Instana.png 576w", "/instana-humio-hybrid-systemZ/static/7d51529bfec5170b1ba916f4285a583c/3cbba/Instana.png 1152w", "/instana-humio-hybrid-systemZ/static/7d51529bfec5170b1ba916f4285a583c/0b124/Instana.png 1728w", "/instana-humio-hybrid-systemZ/static/7d51529bfec5170b1ba916f4285a583c/91583/Instana.png 1886w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Note the middle portion of the home panel lists applications currently being monitored by Instana, including applications with z/OS components.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "24.305555555555557%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAFCAYAAABFA8wzAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAwklEQVQY032QS27CQBAFfa2EQ4SsIOePwgJsbOPP9PRnKhnDEtJSrZ766amat48D0+1GPwys84ycTuSuo14p5SWUQlSikN0ZVVnUaHafXxSgu/ZIVgJwwNxxj6fULMIZkvHdr6gIozj9ONHs9ke8xFaYJOPumNn2ZPYcNcPNGMX4GVZEhPNidON8L7TinC8tKQke9wWviLqy6gD6x8IsQrsa3TDRvO+Pmy9VJSL+9VbzRZ10acltixaYsxHuJAvyn8NfcsR93C5imxUAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana apps",
        "title": "Instana apps",
        "src": "/instana-humio-hybrid-systemZ/static/d248a1c3429d31d2344346251e89cdb0/3cbba/Instana-apps.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/d248a1c3429d31d2344346251e89cdb0/7fc1e/Instana-apps.png 288w", "/instana-humio-hybrid-systemZ/static/d248a1c3429d31d2344346251e89cdb0/a5df1/Instana-apps.png 576w", "/instana-humio-hybrid-systemZ/static/d248a1c3429d31d2344346251e89cdb0/3cbba/Instana-apps.png 1152w", "/instana-humio-hybrid-systemZ/static/d248a1c3429d31d2344346251e89cdb0/77c84/Instana-apps.png 1410w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`To see all the Applications being observed   Click on ‘All Applications’ `}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "558px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "27.430555555555557%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAFCAYAAABFA8wzAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAwklEQVQY032Qy07DQAxF5/8/Az6gW9ixoMuuuyQRKoR2SCiNkonH9qmSJoIiwNKxvPC9fgR351/MJkwV3OlFaZNg7sReaZJStZnYHOlTInwX28yVIdfRSSZJ5jgYD7ue9Wtisx+o9pGyfCbYON0MJunMbMy4XV3Tbbc0d/d0VTWZ+m+aOYexSFkp31ue4okinth9dGjONLc3vKxWvK0fqYsCFbkI/WJg/sVyUVgahmwkUUSNbD5t8Hk4ID9OXt7w18/P4kqGGDay4ygAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana allapps",
        "title": "Instana allapps",
        "src": "/instana-humio-hybrid-systemZ/static/c09eaff46c787e0479cd3a2c2719abda/e0f21/Instana-allapps.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/c09eaff46c787e0479cd3a2c2719abda/7fc1e/Instana-allapps.png 288w", "/instana-humio-hybrid-systemZ/static/c09eaff46c787e0479cd3a2c2719abda/e0f21/Instana-allapps.png 558w"],
        "sizes": "(max-width: 558px) 100vw, 558px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`You should now be looking at the Applications panel that shows application performance and availability across the various applications in the lab environment. This panel shows a summary by application name, with number of calls and call latency.  Note that you may sort this display.
Click twice to the right of Name to sort the display in descending order`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "958px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "35.06944444444445%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAYAAAAIy204AAAACXBIWXMAABYlAAAWJQFJUiTwAAAA4UlEQVQoz6WRS04DMRBE5/7HyyonYEEC8Uzi/thtP2RPgoIAscBSqX92tat7OaXE6+WCuZOzoGaIKOv1NnOtNSKCiPYHgt47y3sW3rKQ1RBzxB1RI6tOO3OjyTf4U223NYJlW1fOpzPrtkEEuPOfs5gZqko+HkmHA5YSHabU1vq0tZQ97h0vZUoc8kYcUeltj6fkVTKXLWMik2jiXpyPWuOm9uk/5jpiekdL5epBrfVO6Ip4UNrPw67R0BLE+GnERDzujga1kayiXnbCPLZr5dft7SRPfo0vzeiNl1shiU99H8nLJe9pcSOPAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana zapps",
        "title": "Instana zapps",
        "src": "/instana-humio-hybrid-systemZ/static/ec0f1d004f12a428167624986dd2f9fc/a0488/Instana-zapps.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/ec0f1d004f12a428167624986dd2f9fc/7fc1e/Instana-zapps.png 288w", "/instana-humio-hybrid-systemZ/static/ec0f1d004f12a428167624986dd2f9fc/a5df1/Instana-zapps.png 576w", "/instana-humio-hybrid-systemZ/static/ec0f1d004f12a428167624986dd2f9fc/a0488/Instana-zapps.png 958w"],
        "sizes": "(max-width: 958px) 100vw, 958px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`You should now be looking at the Applications display sorted in descending order by Application Name.
The application of interest for this lab section is zHybridApp.
Click on zHybridApp to drill down for more detail on the sample z/OS application.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "880px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "20.48611111111111%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAECAYAAACOXx+WAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAnklEQVQY051QiQnDMAz0/jO1M2QGp9DEtC4JSWNb3xU7zwAVHBKSuDvJzdME3z/wHAYM4whVBcxgZvgnHDNjWVfkUkDE0GNQ6dQMqnblKsIiYJZWV4gIiPnac4UIMUYwlZ0oJeQQkL2HijbHJypBzhkppVbXHhE1Q3LsuLl88Vo3vJNg8T3i/YZP12ENYRc4nJwvWDJjI7lOrFeds5p/pXs5d6+FgpYAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana zhybridapp",
        "title": "Instana zhybridapp",
        "src": "/instana-humio-hybrid-systemZ/static/a5c2295f23b038e0096a0426bf9e6074/8edf0/Instana-zhybridapp.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/a5c2295f23b038e0096a0426bf9e6074/7fc1e/Instana-zhybridapp.png 288w", "/instana-humio-hybrid-systemZ/static/a5c2295f23b038e0096a0426bf9e6074/a5df1/Instana-zhybridapp.png 576w", "/instana-humio-hybrid-systemZ/static/a5c2295f23b038e0096a0426bf9e6074/8edf0/Instana-zhybridapp.png 880w"],
        "sizes": "(max-width: 880px) 100vw, 880px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`You should now be looking at an overview display for the zHybridApp application.  This display provides a wealth of information about the zHybridApp application, including call counts, processing time, call counts by status and call latency.   `}</p>
    <p>{`Note that you may look at information about zHybridApp for various time frames.  For purposes of this exercise it is recommended you look at information for the Last Hour.`}</p>
    <p>{`Click in the upper right area of the display and select ‘Last Hour’ if it has not already been specified`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "518px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "33.33333333333333%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAYAAAAIy204AAAACXBIWXMAABYlAAAWJQFJUiTwAAABS0lEQVQoz02R207kMBBE8/8fMm9cfoF3tA/srgRKYJ1MRgMkMBPHdzs5K5sMwlKpu8tdUnV3ZazDWIsxFq3Nd1RKo5XGOk/pMRalDXPmtzz3WetKfUEVYiIsK26FCNiUCHzlGWcpizDj8mLWxFiiNoYYIyHEwlU+JqI2xGEkjSP1/S/GuiY0DfLujqZuaNuOh4e/vPxrGYYRay0hBLz3NC+C4X2gPxzJ5qrs4vP3H8RuR391zfHmhv72lvbqmv1uh8tje895kkyTLKOvgA9fDi+OU1oKV2WrJkTUsrL/OPEqFTImZFw4hYRUmjnvyociGD5OTHJmkqrgLOdtpxZj/bbDEFmXlcenBiE6+v2BVnSIZ0HbHXgfP8sx8oEe62de3wbatkeIPV1/ZJoVclZo46icD2RYF4ogx1JnPkR+/mcH2YDfeHuB81uP5z8BnxcXDuTIxAAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana lasthour",
        "title": "Instana lasthour",
        "src": "/instana-humio-hybrid-systemZ/static/387cc99c620d51082054568063361917/d7f6f/Instana-lasthour.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/387cc99c620d51082054568063361917/7fc1e/Instana-lasthour.png 288w", "/instana-humio-hybrid-systemZ/static/387cc99c620d51082054568063361917/d7f6f/Instana-lasthour.png 518w"],
        "sizes": "(max-width: 518px) 100vw, 518px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Note that in the bottom center portion of the display you will see the ‘Top Services’ portion of the display.  In z/OS context the Top Services will include key mainframe resources, such as CICS regions, Db2 on z/OS databases and z/OS Connect regions.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "47.56944444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABvklEQVQoz32SS28UMRCE56fDDSHxG5DgxAUlwJ0Lh0RCIiJKJETYJYjNJuxrxvOwu+32F9m7IuHCWKUea+zq6qpp5psl32a/uPq5YH59w5flHy6dI8WE/geisdbJB9rO0bmecfI02zBwu96yuF2xvFsz22y57ntElBCEGNM/0Bgf9qkQ655cY61N1zmSGbmsnMGsonQr3VOyA9IBhuuH/TczzKzWgtKs0RDBChH1+XyX+N1nskodo6i0nDHL9XJp6oaRaZqqSrLRhsTXVSAWwpffP/L07A0vzo94fnHMk7O3PDs/ZuFWxDKyKvmgpBKaEVRRlTpmeU+WGTXhRWg+LS84mp3wbn7K8eyED7NT3s9PuOnWJNG9NyKkAzQIk/fVu0I2hXDwTxl9oKlzRiAB+VABFd1f7DqS9/SS6INWH4u/PoS/vuqjwJppHGl7R+scEpWUrWISZeNG+m5Ak3HVRn7spPrX9wOunC/pSqy+RstItL3ChwT3KRafiprlENkpbILRidEpXN+u8d5XP8uokxdyLokaJKUp/5sEqWnKI4xB2UwRJ8Y2JPpiesrsOlcVlvNBpPo7eOHVZcvry5Z7w6oDAAp/7xwAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana zhybriddetail",
        "title": "Instana zhybriddetail",
        "src": "/instana-humio-hybrid-systemZ/static/aedf8269a7195215eab6cc5b200102aa/3cbba/Instana-zhybriddetail.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/aedf8269a7195215eab6cc5b200102aa/7fc1e/Instana-zhybriddetail.png 288w", "/instana-humio-hybrid-systemZ/static/aedf8269a7195215eab6cc5b200102aa/a5df1/Instana-zhybriddetail.png 576w", "/instana-humio-hybrid-systemZ/static/aedf8269a7195215eab6cc5b200102aa/3cbba/Instana-zhybriddetail.png 1152w", "/instana-humio-hybrid-systemZ/static/aedf8269a7195215eab6cc5b200102aa/0b124/Instana-zhybriddetail.png 1728w", "/instana-humio-hybrid-systemZ/static/aedf8269a7195215eab6cc5b200102aa/1a9d8/Instana-zhybriddetail.png 1899w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Click on ‘View All Services’  under Top Services`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "768px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "47.22222222222222%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAABYlAAAWJQFJUiTwAAABQElEQVQoz42SW04DMQxFu0+Ww7ZYAB+of4WWl3h1gHQmncwzycQ5KJNWQiogLF05sayj68QL6z26VOid4qMoaIwhR+SnWO4cZxcV51cGYwx2GNBas9earutZOO/5bB1vxlINE8bJr2qcoIbAeu95NBO1DXNdDxPb0tD1QwYm2KMeKYdAbYX9H0qA3gutz/fayWzk7k2x3txm4HvreG0c2gp6lJz/UDVmHe9l77kvSlY3axbpDV/rkWoMtD7ODpLLfyuNPAYetjuuj0DVJZeeonGUh3es/6nUu7eBF6W5WR+ACfRUO55rS9FNlKOwG8KpxtNa6v3sJ54+SjabDQvrEtDOMNVPND6ejHX85SkIEuO8UFEiIkIQmXNVaVar6+yQmHcupuZv5xRO0mgO4xwWmIqC9vKSbrnEbbeHlc1wpRRfeTK1Y0NfxJwAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana topservices",
        "title": "Instana topservices",
        "src": "/instana-humio-hybrid-systemZ/static/6b74162cc94fcffc3c50fb10d72eb5a0/d1b73/Instana-topservices.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/6b74162cc94fcffc3c50fb10d72eb5a0/7fc1e/Instana-topservices.png 288w", "/instana-humio-hybrid-systemZ/static/6b74162cc94fcffc3c50fb10d72eb5a0/a5df1/Instana-topservices.png 576w", "/instana-humio-hybrid-systemZ/static/6b74162cc94fcffc3c50fb10d72eb5a0/d1b73/Instana-topservices.png 768w"],
        "sizes": "(max-width: 768px) 100vw, 768px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`You should now be looking at a display that shows the various Services, as identified by Instana, that make up the zHybridApp sample application. `}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "38.541666666666664%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAAAsTAAALEwEAmpwYAAABGUlEQVQoz42S0U7DMAxF8///xhMPSEhjoE0TBXVV1zS1HacX2W6BSTxQyUqcxifXN0kv/QVPhzc8H884HM94uHR4HEdoVcg/glmQ54LblDGXBWlYJnT9Faf3T3QfPV6vA05T9o3Eglr1z5BawVJ9jLl4JCYGsGLF9q0roA2tNajqFve5zZkZC5GPYmAJaCpOV1S1U6OoetHqIMsXUXANsLVp/61YW8NM4rlHVaTRTpFIrIiI3QvbbGs2Zq4oLA60Nq24LOTwoXBYo2FDyizfQBHBQuxhINlUTfQD3BUSs9eYQvdyBxY3dQO6AnGFexsGsZbJlf0GhqpMcSmhUJFuxL45nkHzVuwJ7GrMQ2/ZvWrbzUbLJoL4XuEX02dyNsnY400AAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana zhybridtopservices",
        "title": "Instana zhybridtopservices",
        "src": "/instana-humio-hybrid-systemZ/static/4ec7beaeb0377abcc4a4bea3243b1f76/3cbba/Instana-zhybridtopservices.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/4ec7beaeb0377abcc4a4bea3243b1f76/7fc1e/Instana-zhybridtopservices.png 288w", "/instana-humio-hybrid-systemZ/static/4ec7beaeb0377abcc4a4bea3243b1f76/a5df1/Instana-zhybridtopservices.png 576w", "/instana-humio-hybrid-systemZ/static/4ec7beaeb0377abcc4a4bea3243b1f76/3cbba/Instana-zhybridtopservices.png 1152w", "/instana-humio-hybrid-systemZ/static/4ec7beaeb0377abcc4a4bea3243b1f76/0b124/Instana-zhybridtopservices.png 1728w", "/instana-humio-hybrid-systemZ/static/4ec7beaeb0377abcc4a4bea3243b1f76/0392b/Instana-zhybridtopservices.png 1883w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`In the Services display you will see information on the various resources that make up the zHybridApp.  Some of these Services will be off the mainframe, such as zapm2-nginx and SimpleProxy.  In addition, you will see various z/OS specific Services, such as CICS, Db2 and z/OS Connect.
CICS is one of the transaction managers used commonly on z/OS.  In the zHybrid application you see three CICS regions, CICSTIVA, CICSTIVB and CICSAOR1.  Db2 is part of the zHybridApp and the display above you see a Db2 subsystem called DSNA.  You will also see a reference to z/OS Connect region, zceebill. z/OS Connect is an API enablement capability for z/OS.  In the above example z/OS Connect functions as an API enablement interface to CICS region CICSAOR1.
In the Services display you will see a list of the relevant services for zHybridApp, the type of Service (CICS, database, z/OS Connect and more), the call counts for each of the services, and latency information for each Service.`}</p>
    <hr></hr>
    <h2>{`2-2: Analyzing zHybridApp`}</h2>
    <p>{`From the Services display you may drill down to see more information on how these Services are being utilized within zHybridApp.
Click on CICS Region CICSTIVA    `}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "734px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "19.791666666666668%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAECAYAAACOXx+WAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAtElEQVQY002OW24CMQxFZ/+b4o9/1gAqFYyGPJxJ4jxOlUwptXTsey35ysu3OIxkvl6CCQnNSh6UeqAFLZU9F3zUqcfuvb8/Vm63O891I2VlWXdPypUQM6k0KkzKCH0f/s4j5KMH1gckRPaYpl+2KCStmFyJjyfudGI9nzGXCx3ofXZK7bjYp/+PsY7XZhAJtNZYthRI2pDxpRfkeiVbS1GFv0AorSO5c7hPWedxzhPCTmudH6OyNzPr53EjAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana cics",
        "title": "Instana cics",
        "src": "/instana-humio-hybrid-systemZ/static/32156f687d0df400b8f11c18f5f93a68/0f264/Instana-cics.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/32156f687d0df400b8f11c18f5f93a68/7fc1e/Instana-cics.png 288w", "/instana-humio-hybrid-systemZ/static/32156f687d0df400b8f11c18f5f93a68/a5df1/Instana-cics.png 576w", "/instana-humio-hybrid-systemZ/static/32156f687d0df400b8f11c18f5f93a68/0f264/Instana-cics.png 734w"],
        "sizes": "(max-width: 734px) 100vw, 734px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`You should now be looking at the summary display for CICS CICSTIVA.  This display will show call counts, rates, processing time and latency.  Under the Top Endpoints you will see the transaction being executed within CICSTVA called CPIH.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1026px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "44.79166666666667%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAABYlAAAWJQFJUiTwAAABm0lEQVQoz3VSXWscMQzcv1ySl0BfSkqTg6P0R5X+gJTSQgmkD/24Sy5367UtS5Y0Rd407UsXtGNjMR7NeDq72tCvcsTHL7d+8/kWn75+w4fdHrtKMDWwdEjX/1acn07JT3NCLlWni+07Ihf83B98d/+I/eGIu3nG3Biqit7XkmdcL+j6d88s3gNFdLq4fksA4OsHNUcThUhHygVEDao2yEeZIZeCUBTrqK7mVXQlfHm1HYTUyGGKJI73PxiFFTklzCnBzOJCmHu0olBDWhKEBaYK6uY3D4zGofDNlqIt1eyVCUdacGoZhQldZKgKL+1JYSCLoMlqyRi5i5t52KDT+eWGmjEel5M/LEfcp0fs0wHHPIMqQVoDUxvozJDGKJVQGw+yxgJi9ifU6cWrqzFyreThG0KuA26OJTwMIneER3czQ3glXJYlwkCEoWoePveuOp1dXg/CXIpXauMZ/ElwIUZuHaSOQ+v4njsKd+RQWPLaKx1mOsw1M53OX28GYZPuSyHkQs/vK0KITvsnkPgzMxrRUBhItXpMQq3pb0dosZiDU3yUAAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "Instana cicsdetail",
          "title": "Instana cicsdetail",
          "src": "/instana-humio-hybrid-systemZ/static/12cfcb0ef938cd7ca83364084460e95e/cb6df/Instana-cicsdetail.png",
          "srcSet": ["/instana-humio-hybrid-systemZ/static/12cfcb0ef938cd7ca83364084460e95e/7fc1e/Instana-cicsdetail.png 288w", "/instana-humio-hybrid-systemZ/static/12cfcb0ef938cd7ca83364084460e95e/a5df1/Instana-cicsdetail.png 576w", "/instana-humio-hybrid-systemZ/static/12cfcb0ef938cd7ca83364084460e95e/cb6df/Instana-cicsdetail.png 1026w"],
          "sizes": "(max-width: 1026px) 100vw, 1026px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy",
          "decoding": "async"
        }}></img>{`
    `}</span>{` `}</p>
    <p>{`The zHybridApp originates on the HTTP tier.  The SimpleProxy Tomcat application issues Web Services calls to CICS region CICSTIVA.  CICSTIVA invokes transaction CPIH in the CICSTIVA region running on z/OS. CPIH initiates the business transaction LGICUS01 which accesses VSAM files, performs a CICS MRO connection to CICS region CICSTIVB to access another VSAM file.  LGICUS01 also makes calls to Db2 subsystem DSNA.
From here you may drill down to see call detail and get a better understanding of the flow of the application.
Click on ‘Analyze Calls’ in the upper left area of the display`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "818px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "16.666666666666664%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAADCAYAAACTWi8uAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAy0lEQVQI11XMTU7CQABA4V5ZT+IF3BtQ4wLFRIKFBQaMpbWpHRRJ+NOkDbQyzIDTdp4JiQte8m2fo+SOfCVJkwxjSipr2SqFlFuSNEX/lsi9Zb3OUVqD5ShTlKjZnGzos1caZ7pJCNIJcTYj/Jww8AV9P+bJixgEgud/r4KXQPAwX1JbLLhYftEZj8l7PVaxQP1sDnMnyqa0vof08xFtz6PecKnfudQaj1zfd7lqdg4um11ubl3OwjdOo4iTMOT8/YNK7zBAUVmMKfgDIvzXq9QPVBwAAAAASUVORK5CYII=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "Instana analyzecalls",
          "title": "Instana analyzecalls",
          "src": "/instana-humio-hybrid-systemZ/static/5fd0bd2a29447c6f54d8513ddcf461c8/96d67/Instana-analyzecalls.png",
          "srcSet": ["/instana-humio-hybrid-systemZ/static/5fd0bd2a29447c6f54d8513ddcf461c8/7fc1e/Instana-analyzecalls.png 288w", "/instana-humio-hybrid-systemZ/static/5fd0bd2a29447c6f54d8513ddcf461c8/a5df1/Instana-analyzecalls.png 576w", "/instana-humio-hybrid-systemZ/static/5fd0bd2a29447c6f54d8513ddcf461c8/96d67/Instana-analyzecalls.png 818w"],
          "sizes": "(max-width: 818px) 100vw, 818px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy",
          "decoding": "async"
        }}></img>{`
    `}</span>{` `}</p>
    <p>{`You should now be looking at a display that shows call counts, erroneous call counts and call latency.  Towards the bototm of the display you will calls by call group.  In this application component you see one transaction, CPIH (a standard CICS Pipeline Handler transaction).`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "33.68055555555555%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAYAAAAIy204AAAACXBIWXMAAAsTAAALEwEAmpwYAAABFklEQVQoz2WRXUpEMQyF7+J8EBfgu4tyJSqigg8uwBcXoOKLDqM4k96mzc89knSQ0Sl8NKTkJM2ZyszYUAGVGaXMaF0O6BLoAU0UtXVsibClgrkyJlXLojLXISAC5obWO7j3vEUV7v6HxR3dDJ9EoKAUMDOm6J5CrcHNYFFsNuLAHWqGaJz3DjPPnOzlo/k0HhTfhUFNQdyxYck4xKJRFC7L8ktMGIPs54IYYAqx6HJ2v8bx5Qqnt2ucXK1wdPGB86ct4GOKEE/Ms1B3uaZjBWIjzi+LKB7eCm5eAsLda8H1M+HxvUJiJWnA2G/XYUjU5O4rg1tPc2iYMh68VwCG/8f3voRlycWHQFPD3ARfG0oTw+VaK34A97ceAGyOO+gAAAAASUVORK5CYII=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "Instana calldetails",
          "title": "Instana calldetails",
          "src": "/instana-humio-hybrid-systemZ/static/4035e221662316c8d79013d8c540a240/3cbba/Instana-calldetails.png",
          "srcSet": ["/instana-humio-hybrid-systemZ/static/4035e221662316c8d79013d8c540a240/7fc1e/Instana-calldetails.png 288w", "/instana-humio-hybrid-systemZ/static/4035e221662316c8d79013d8c540a240/a5df1/Instana-calldetails.png 576w", "/instana-humio-hybrid-systemZ/static/4035e221662316c8d79013d8c540a240/3cbba/Instana-calldetails.png 1152w", "/instana-humio-hybrid-systemZ/static/4035e221662316c8d79013d8c540a240/0b124/Instana-calldetails.png 1728w", "/instana-humio-hybrid-systemZ/static/4035e221662316c8d79013d8c540a240/a91d8/Instana-calldetails.png 1820w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy",
          "decoding": "async"
        }}></img>{`
    `}</span>{` `}</p>
    <p>{`From here you may drill down to see call detail.
Click on cics/CPIH   to see a list of individual requests.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "678px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "24.305555555555557%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAFCAYAAABFA8wzAAAACXBIWXMAABYlAAAWJQFJUiTwAAAA3klEQVQY03WO60rDQBCF8/6vIPgE4gUfwF+CglK0P4orbW0bzW2TzW52N6Qk+STRqqQ48DEzh8PMCbz3GGNwztH3PUMN/TB/C7903Vf/p4LKGDabN7a7kG5iHA+3LR2M/Oh/nk4JbL1H2gZVeaS2pMqQqoqkMMjKo/Y9WlvK95hMLMnuH8izgsLW5MZRTAii0nGz1szmC1ZhwmK543H+wtPrlg+xIjw5RZxfIc4uEJfXiNs7IlmSakda2iMC7epxOKQLk5wwlsS5Jkkk69kz0bAPiZoO1bRjssEvtTviE6hPfRhdKFCxAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana requests",
        "title": "Instana requests",
        "src": "/instana-humio-hybrid-systemZ/static/ac471a08d77515737eca9ad50524a60c/413af/Instana-requests.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/ac471a08d77515737eca9ad50524a60c/7fc1e/Instana-requests.png 288w", "/instana-humio-hybrid-systemZ/static/ac471a08d77515737eca9ad50524a60c/a5df1/Instana-requests.png 576w", "/instana-humio-hybrid-systemZ/static/ac471a08d77515737eca9ad50524a60c/413af/Instana-requests.png 678w"],
        "sizes": "(max-width: 678px) 100vw, 678px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`You now see the display expand to show individual transactions listed towards the bottom of the display.  This display will show the transaction code, the Service name and the latency time for the transactions on the right.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "38.888888888888886%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAAAsTAAALEwEAmpwYAAABRUlEQVQoz21RuU5EMQx830YJPRJ/iRAUUNEgxEdAA6z2gN1N4iR2nGRQ/JZLUIziHOOMZ6aYMnwgBIqgmMBS/kDKgP5BLgWD73yYV+cx1dqQma3ZIGYR21szFogUqFa01r5QW0NvDUEEex8QAhnfOYepqBpZRdBbRatqq9UHstb6P/T33nmPqfduyjYh4z0VbCNjQ4JtVohWMDNqrRjvPqGqhp9nvQNEhGko2WXF2c0Gx5drnF6/4eRqjaOLFc4fCUC1xvWgdlj0raqBdR5farcspvFTloKHBeHuNeLuhXC/iLh9JjztMtqwpAz8DGauY2ZDZgGlbMFMY5yUBeQ9VNi8q8NPnUMJiQ2U5/p9H7CnDBcZy63HeuvwtvdY7zxCTLNC+00KYkyg5QqcMkrrNtIIZtyXQ9IjiHnsYUE3zlDIzoFjxAf+dmsD2aDkCwAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana requestdetails",
        "title": "Instana requestdetails",
        "src": "/instana-humio-hybrid-systemZ/static/87bd309b49d6b8dcaa5dc6a27d97063f/3cbba/Instana-requestdetails.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/87bd309b49d6b8dcaa5dc6a27d97063f/7fc1e/Instana-requestdetails.png 288w", "/instana-humio-hybrid-systemZ/static/87bd309b49d6b8dcaa5dc6a27d97063f/a5df1/Instana-requestdetails.png 576w", "/instana-humio-hybrid-systemZ/static/87bd309b49d6b8dcaa5dc6a27d97063f/3cbba/Instana-requestdetails.png 1152w", "/instana-humio-hybrid-systemZ/static/87bd309b49d6b8dcaa5dc6a27d97063f/0b124/Instana-requestdetails.png 1728w", "/instana-humio-hybrid-systemZ/static/87bd309b49d6b8dcaa5dc6a27d97063f/65d9c/Instana-requestdetails.png 1836w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Click on cics/CPIH   to see detail for an individual request`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "432px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "67.0138888888889%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAABYlAAAWJQFJUiTwAAABzElEQVQ4y51TW27bMBDUnXOVfOYGOUB/coH0BQMpoDaOa8u2VD0jipTEN6cgaQsOkLRBFhgttcAOd3aXCaUMWZZhs93hmOewzsGbc+5DSDjnqOsam9/bQBzpAqP/nH/wXkuE0lBKQxsL5QA6Cwwjj37iAct55EvsLSScC9zvCdKK4SF9xLHukZUtfm5zrA8lHrM/WO9LlD1DTUZUZAz+LSRKCnx6IvhWMNx//hrInrICP9Y7fH/4hS+rFPuyQzNMMcn7fyBhXg4d0XtMEh2dkdcdDmWHY9niWHVoCEM7TGiGEe1/kEilMc489FAqhZkLCKkglII89db/z0KAC/k6uIgQEomUCtY6ZIcczz1ZVubse0KhtHllni5ugrUvp+yr8lNu2g6UjSGojYE5oSdDqNBYG2NnD2ChohR6s4HRGokn41IuN5iLG89LfmnW2riVwwCTpuhvb7G7vkZ+dxcuCBVabbGfGjxLFpKqqkLTNOHcTyIMqyATaspDTHUdqqsrbG9ukK9WYJwvqx8IjbaoxQCmY8I8z/AvyBuZJAauAmk/RyVaCFRFAfWipVHZSbKKr8sBxkRJXm2U7y6eoQsxeyrHGgOtdcgJvbUWfwEy7Ow0APu0JAAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana indivrequest",
        "title": "Instana indivrequest",
        "src": "/instana-humio-hybrid-systemZ/static/84312b36123093b72f3808b2a123f97b/51a28/Instana-indivrequest.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/84312b36123093b72f3808b2a123f97b/7fc1e/Instana-indivrequest.png 288w", "/instana-humio-hybrid-systemZ/static/84312b36123093b72f3808b2a123f97b/51a28/Instana-indivrequest.png 432w"],
        "sizes": "(max-width: 432px) 100vw, 432px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`You should now be looking at the detail for a selected transaction.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "46.18055555555556%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAAAsTAAALEwEAmpwYAAABc0lEQVQoz3WSy27cMAxF/f+f012/o4uimwbNvJwZ27IlUaKeNyDtTJJFBRCyKemA95LDv+sbjCVsFLGsFrNZsTkPTxEUIkJkcMp75PLcY8oa8p9ywUSEx2IwvFyuWC2BAmOaF72QS1VQyhmBBZg0H2JELgUUGb1WeO/hnEfgpPmcM4bzOOpjSczLAqKA2po+LqUg8n4mESPr2WYdzjZhNBbbusIGho9JKx1u9wci7xUsiwEzK0hW7/25f3y31gBU/F4z/t5mkLWgmLRK4QyncVS/RN5iDFJpKnmHfMJ2YIfljh+/Cn7+AbbTGWae1VMKQT1VoJgvQGMMHAOp4r9LuOPWcNoAe71inWc4CmpVdB7D7TF9kyyV1NpU2teQfGv9kNwUHqcJfrM6FeQJwRgMrzeRHI4KV3giOOe0Y613lFq1EdJp8VaAOZdnjjmpQpkSlXy53xGCNKLuc5cKuNSjsr77w1knQeCS38FdlckI6UweTXkHi/271tcjCoMAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana transaction",
        "title": "Instana transaction",
        "src": "/instana-humio-hybrid-systemZ/static/5c7b2511e6cf46fc09ded182be6f3492/3cbba/Instana-transaction.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/5c7b2511e6cf46fc09ded182be6f3492/7fc1e/Instana-transaction.png 288w", "/instana-humio-hybrid-systemZ/static/5c7b2511e6cf46fc09ded182be6f3492/a5df1/Instana-transaction.png 576w", "/instana-humio-hybrid-systemZ/static/5c7b2511e6cf46fc09ded182be6f3492/3cbba/Instana-transaction.png 1152w", "/instana-humio-hybrid-systemZ/static/5c7b2511e6cf46fc09ded182be6f3492/b5f6b/Instana-transaction.png 1608w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Scroll the display to see the call information summarized towards the bottom.  This portion of the display will show the sequence of calls that make up the chosen application flow.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "52.77777777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAABrElEQVQoz3VSy24bMQzc//+SAK176Sm99dwP6KFAHQSFG2/24dWDokiJU0h2bDhICQwWpKjZGYrDeCIsgZBYkEWRs2B1EUtICJHAnM91kTu4EBBi7D0p3+oDM0NKhZmh1trRGrRUiCpKabXbWam1n1FiECWElMFSrvcHAD15Dy0FpZRrDrQvrhGJ4JzHFghbTPDEXcigWrqKRtChpUu/5hc0tbUoxijYnzISMyglRErgrCBuShVDzhlm9aICF+n3alt0+yL48Zfw+EwQyX2GlHK373yAaMFwdA7LesLqIyhrY7z84D0Mh82wegVQu7Jm+bQ5JD6TdsIXEhxmj9fFY6WKYq29TeyGepmbY+DoACnAsq44bRumeenk7bU7IU87HJ4ecPrzFfSyQx4/IRy/weYvsPnzHeq0QxkfYO475mXtr9yUcZaushMiPxu7X7Ydf1rafpvQ3nLYm/HTf7A3yNGmebYQo/kQzUeyQMkSZxuanYkUkTKkni2Kolu3D6y/bc74OsG3xRft6/KGATBlEV03r86xZi3aohRVs/ohAOg4TeojacqixLkjcdZ/IVdWfsCG8nIAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana callsequence",
        "title": "Instana callsequence",
        "src": "/instana-humio-hybrid-systemZ/static/1b8b3124901f3aa46e2e63813159fe2c/3cbba/Instana-callsequence.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/1b8b3124901f3aa46e2e63813159fe2c/7fc1e/Instana-callsequence.png 288w", "/instana-humio-hybrid-systemZ/static/1b8b3124901f3aa46e2e63813159fe2c/a5df1/Instana-callsequence.png 576w", "/instana-humio-hybrid-systemZ/static/1b8b3124901f3aa46e2e63813159fe2c/3cbba/Instana-callsequence.png 1152w", "/instana-humio-hybrid-systemZ/static/1b8b3124901f3aa46e2e63813159fe2c/31986/Instana-callsequence.png 1338w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`In the Calls display you can see that the call originated in a Service called zapm2-nginx, then went through a proxy service called SimpleProxy.  The call next went to the mainframe (esysmvs1.ztec.dmz), and then ultimately was sent to CICS region CICSTIVA.  You can see the relative latency times for each step on the way.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "973px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "47.56944444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABmklEQVQoz3WSTYsTQRCG50d70YOIoh4Vb/tjPHjyrCzCoptNyJDsTjKT+ervrnpkMtmomC146Kaorq6Pt7DGICL8MUVPt5gSqsolm/zOe0iem9rx7GvH57WlaJ0jxUhMkZQyonNSsRaN8fz4ElO8DZmDidwPkTFmivU40hxaqrqh7Qc6F/HGMl5f47bbY7Uqgsj0maAqc0cqhKQsa2VVZ1LwR1/RxMym7dk1E+2RxkNsDpjFHXk05xFM3Z8BssDDAOUBXMhkUQoVx7Krqfb3bHcV7dDSjR0+DLgsDIs7xh/fseUtkg2aLZoNki2IxQVL3Rui75AcKKiuaFbveLh5xf7nB+zqE275Gi3f0Nx+ZFxd4b49Jy1eouXbf5DTyeY9rF+Q2y8UmjtIe6LZUle/6KsSO+wIfkeyG5LbgB7Q3KBx/x9yYsqRk6GYZjOJpveJvhvxzhGE47Zjmvl7bk/BaabFFBlFKIeBdjC4kHA+zWGT1pwn5zxv97TlS0zxWYTiLFxVur5nX4+MXWQMiSRCCPEok6e0+MhcofAb1BICwez/EwUAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana callsequencedetail",
        "title": "Instana callsequencedetail",
        "src": "/instana-humio-hybrid-systemZ/static/daf2903d518f0cc094dad7ec327fd084/9a0b9/Instana-callsequencedetail.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/daf2903d518f0cc094dad7ec327fd084/7fc1e/Instana-callsequencedetail.png 288w", "/instana-humio-hybrid-systemZ/static/daf2903d518f0cc094dad7ec327fd084/a5df1/Instana-callsequencedetail.png 576w", "/instana-humio-hybrid-systemZ/static/daf2903d518f0cc094dad7ec327fd084/9a0b9/Instana-callsequencedetail.png 973w"],
        "sizes": "(max-width: 973px) 100vw, 973px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Note that on the right portion of the display you see information about the CICS transaction.  This includes the call type, and the CICS Task Number.  The Task Number is an important item of information to identify the specific CICS task that executed the transaction.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "654px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "46.875%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAABYlAAAWJQFJUiTwAAABO0lEQVQoz4WS0XKDIBBF+/9flNf2sfmGmqSpmhgEERRZhNtZJommyUydYVxhPXt3L2+9MSAipJRQn85opUKYIzwFUJjz4u8cx4QAgFbn13caJ8/x6e0GjCmh0z0mv4A4mfeEaGEpwO0PEJsN9P4ASlgXTRyHMC9AVljVJ3S9uSuaPEFIhdFNmChg0D20aPP+reBN4RMwxpjbHUb38EPTXNDpa5E5IiSsW30GGmvvCsuywrm55MQ5xgy+iBZuIhCr8QR/Ba9n/ADkNq0x4IdholWQqoOxQ052njgRBGBmQ+wAP4x/oQvwqyiglMpAbo8LNGzC6HKylArGjnDFDvJzi/P7BwapsuMvgcVufwdWVY2fss6zzPPxhGNZZafb7Rbq+4jpv5bXQNVpiFY+mKJ1j97YfP/yHVycfanwF0gwuPibc2oQAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana callsequencemarkers",
        "title": "Instana callsequencemarkers",
        "src": "/instana-humio-hybrid-systemZ/static/c1e7d4d5de7df2c4b7673125b1d3ae0c/3c42d/Instana-callsequencemarkers.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/c1e7d4d5de7df2c4b7673125b1d3ae0c/7fc1e/Instana-callsequencemarkers.png 288w", "/instana-humio-hybrid-systemZ/static/c1e7d4d5de7df2c4b7673125b1d3ae0c/a5df1/Instana-callsequencemarkers.png 576w", "/instana-humio-hybrid-systemZ/static/c1e7d4d5de7df2c4b7673125b1d3ae0c/3c42d/Instana-callsequencemarkers.png 654w"],
        "sizes": "(max-width: 654px) 100vw, 654px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Note that underneath the cics/CPIH call you see other call information, including a call to read a VSAM file, a call to a Db2 database (DSNA), and a CSMI transaction call to another CICS Region (CICSTIVB).
You may click on other items in the call sequence for more information
Click on VSAM File`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "38.888888888888886%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAAAsTAAALEwEAmpwYAAABPklEQVQoz22SSU4cQRBF6/4nMEKGBUgsLPkevgEb5AULqxq6soYcIiOHh6Lc3aIRKT3l/ONHZA4hJmafyKVSq9GQrCxByFqQnPe1UusVSQQfAusWkFBordGAobXKd80O1NbovX+7n5LgfWANkWSBYyJOjsHcaCn75XP0euq1XM9LKYgWZilYZjGmXVhrwx8n4vuRwceIqu6OzI3RTvRPfamNqpm/Tvj9ElhCInjPFhJrELwoUSvDMSXmbWPZPEH0IvAV6KwC41L3jKyG5jJJJp6w8RBK4dXNHN6PvM0rITf4ItZOgpt0Xqf/pXDzvJuwEphQykrK2R6l4UR4cyvzuCKi+Ay5XKd8xmptbXLuInh2Z6JDXf5QxxuWlx+450fyvwfy+EQdH+iHn/TD3Sfu6eMtTL+YppHFvozqJWXjA5p+bKCF+QRkAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana callsequenceconcl",
        "title": "Instana callsequenceconcl",
        "src": "/instana-humio-hybrid-systemZ/static/d16356fbb8caa0c68d95741ac9ee2c2c/3cbba/Instana-callsequenceconcl.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/d16356fbb8caa0c68d95741ac9ee2c2c/7fc1e/Instana-callsequenceconcl.png 288w", "/instana-humio-hybrid-systemZ/static/d16356fbb8caa0c68d95741ac9ee2c2c/a5df1/Instana-callsequenceconcl.png 576w", "/instana-humio-hybrid-systemZ/static/d16356fbb8caa0c68d95741ac9ee2c2c/3cbba/Instana-callsequenceconcl.png 1152w", "/instana-humio-hybrid-systemZ/static/d16356fbb8caa0c68d95741ac9ee2c2c/4bae6/Instana-callsequenceconcl.png 1366w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`You will see that this portion of the transaction flow is a call to a VSAM file allocated to the CICS Region.
Click on CSMI
You should now see detailed information about the call being executed in the second CICS Region, CICSTIVB. Note you see the CICS Region name and the CICS Task Number.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "34.375%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAYAAAAIy204AAAACXBIWXMAAAsTAAALEwEAmpwYAAABO0lEQVQoz22Ry24UMRBF+/8/hSVSCAixywfwCAsgiE00wyQz7UfbLr/KB7VBSAmUdFQb6+rU9SI5M1T5O2MwnrFP399o5bvNvLiLhJSJMbIaS0wyqa2zXFLC+I0tRFJp6H8CZ+gYmKgcTCXkhuSC3zYezxdiSoSYaF1Ztlq5N5bHi+FsPbH0XfNJmE7LgZXBvelo7xhrcc6zJcFHIUimtsaiqjykyGm1uCDk1gnSKLUxhqLaJ2NuJddO1z5P3Q2TZKTUSdlP7ns1gI8NH6BU2CWb7k7/wp9trGPbAiJlhgXrqJJZej7Qwnsu54+Eu3eU4w0aP9PCN0b89ASNt2j4wJCvGGtw3v/uUDL+9EA4HFl6/IKaK9zPa8yPl8jpFd28oZzfMsz1M14z1iuGv8GYdXa4Wjd/2B6OiPP8Aki1G7B8AmzhAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana cicstask",
        "title": "Instana cicstask",
        "src": "/instana-humio-hybrid-systemZ/static/d97293edfd87da71342b25fc1b78d7e5/3cbba/Instana-cicstask.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/d97293edfd87da71342b25fc1b78d7e5/7fc1e/Instana-cicstask.png 288w", "/instana-humio-hybrid-systemZ/static/d97293edfd87da71342b25fc1b78d7e5/a5df1/Instana-cicstask.png 576w", "/instana-humio-hybrid-systemZ/static/d97293edfd87da71342b25fc1b78d7e5/3cbba/Instana-cicstask.png 1152w", "/instana-humio-hybrid-systemZ/static/d97293edfd87da71342b25fc1b78d7e5/439a2/Instana-cicstask.png 1368w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Feel free to explore other items in the transaction call sequence.
There is another portion of the zHybridApp you may examine in more detail.  This application flow is a z/OS Connect Enterprise Edition (ZCEE) application.  The application originates again in the HTTP tier, issues REST API calls to a ZCEE instance running on z/OS called ZCEEBILL, ZCEE invokes a CICS transaction in CICS region CICSAOR1, and CICSAOR1 reads a VSAM file as part of the CICS transaction execution.
Click on the Applications icon on the left of the display
Click on the Name header and sort descending
Click on zHybridApp`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "704px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "52.43055555555556%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAABYlAAAWJQFJUiTwAAABqklEQVQoz5WSTU8TQRjH5+BRYtCDiUpMTKQQMRGFGi8CB/kA+v30bPwAmIjGBCiVk4YT6aEoSbds2S37OrOzM/szO6WNYA86ye/wPDPzPP/nRcwurXL7yQu299p4pwN6fZ+e53M6OOMsHKJ0SfEfiGv3FxEPlth+/4Fpp6oqrK0w1mKramRXFcZY57uKuPN8nY21TQ7eviNWin6tbHiOMQapCpI0Q+vSESeps6VUk2RcQdxaWafR3GB3t4VfaDr+gOMgJEoz93kYxaNAWc55nDiiJCXLJekUxPyr1zzcfMPHnX2XtVZmraU0hrJWAVhw9qQ0c3E/BTH7aJWbj5t83T9AyZzucZee5+F5HkUYojod4h/fR+X9wxEzC0+5sfiML61vzhHWkzWWpNvF39oiPDpCRpFTPQ1VFJOqasTdlZfMNdf4tNNyAYMgoNSaylr+1FQ/Hk94TG3neU5Zmsk2iOuNZWYWlvm810ZjiWVBoi0qCMjabZLDQ1S/P+rlRdAxdT9jqS/5hJhrIO7Nux7WAcMkJ5IlMs2If/0kOjlBheF4Kf/a0VybS/39DepS1ZtiLjsGAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana cicsapp2",
        "title": "Instana cicsapp2",
        "src": "/instana-humio-hybrid-systemZ/static/e78f4ddd4f50d0c899d3fd33713112cd/beb41/Instana-cicsapp2.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/e78f4ddd4f50d0c899d3fd33713112cd/7fc1e/Instana-cicsapp2.png 288w", "/instana-humio-hybrid-systemZ/static/e78f4ddd4f50d0c899d3fd33713112cd/a5df1/Instana-cicsapp2.png 576w", "/instana-humio-hybrid-systemZ/static/e78f4ddd4f50d0c899d3fd33713112cd/beb41/Instana-cicsapp2.png 704w"],
        "sizes": "(max-width: 704px) 100vw, 704px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`You should again be looking at the Summary display for zHybridApp you were looking at earlier.
Click on the Services tab
You should again be looking at the Services display for zHybridApp you were looking at earlier.
Click on zceebill   this is the z/OS Connect instance running on the mainframe
You are now looking at the Summary view for the z/OS Connect Service.  This shows call counts, latency information and the Top Endpoints referenced by the Service.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "44.44444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAAAsTAAALEwEAmpwYAAABfUlEQVQoz31S3WoWQQzdVxcslF5q609LH0boE7QKIlr0oujXLt2d32Qykzky2W1FL1w4m8yQnD3J2enF6RkO2eHm8zd8/PIdn77+wNWvexyIoFVRpEJq+y98iFidR0oZ0/H5JRgNPx8ecZgXw61zcMxobWuo/6IpavtzLiKotVqcjs8uMJ7qA7QwdORVrTCmDC4FTdXIDarIq0OKcbvfwTv5dHL63gjD/DCYsLDiwx0hlIoUArwP1tB7h2q32hwC3LpATFlD74rrucCRYDp5c25FQ67uKp7GlCJotUKbQk2lWi6twVHEmj24CgInzMmBpGA6evXWCDkThNlQmVGYkTOhikC4GLpskYgQiZBLAZWCxIzIZPn0ciekQVbrX3vJROCUTbk0xV0QM2PsdXzsaadq6JY/Ew7rB4G5t8MTY7mfQUWwlIZbJwgkiJmxuIBMDO3daoeYQTwdvX63jSwVPmbEMbr9CkNtx7Ch9YHNkPEezSFm+JCe4+ojYiL8Btb9s5kydMguAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana zosconnect",
        "title": "Instana zosconnect",
        "src": "/instana-humio-hybrid-systemZ/static/af06d2a9ce1012af71affb57dffbc581/3cbba/Instana-zosconnect.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/af06d2a9ce1012af71affb57dffbc581/7fc1e/Instana-zosconnect.png 288w", "/instana-humio-hybrid-systemZ/static/af06d2a9ce1012af71affb57dffbc581/a5df1/Instana-zosconnect.png 576w", "/instana-humio-hybrid-systemZ/static/af06d2a9ce1012af71affb57dffbc581/3cbba/Instana-zosconnect.png 1152w", "/instana-humio-hybrid-systemZ/static/af06d2a9ce1012af71affb57dffbc581/0b124/Instana-zosconnect.png 1728w", "/instana-humio-hybrid-systemZ/static/af06d2a9ce1012af71affb57dffbc581/aec32/Instana-zosconnect.png 1871w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Click on Analyze Calls`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "850px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "19.09722222222222%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAECAYAAACOXx+WAAAACXBIWXMAABYlAAAWJQFJUiTwAAABDUlEQVQY01WLO0/CUABG+zuNv8HBgdndwdEFNZoYESVSLSIPIdFgEcEXBKJuEEUotw/o7YNqj4HNs3wnX3IUYTuMhMn3xGTqekg/wJm5TISFaTsMRwbCnmHJCMO0GRsCayaxgxBberhBiDePkOEcfx6heI7P1HQxxw5h+MOCOI7xfR8pJUKY+GHELxAs4iBEDgY4j08gLP4Rg3Iz7qBPejTsN+q9LlpJRy3VOC/V0K51ctV7Lsp3qMXb5WqVOidalbOtbTazKon3Dza6XRKdDrmvIYo60Cl8tqgYz1w9NNg7znOQKZBMaSRTOXbTlxxmy+xnCst/4TvpPKfFGuvtNivNJmsvr6w2Wxz1+/wB+j8ZR7e7dQoAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana zosconnectcalls",
        "title": "Instana zosconnectcalls",
        "src": "/instana-humio-hybrid-systemZ/static/a3030ef488c1aa0985701cbd63d7d78a/e5284/Instana-zosconnectcalls.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/a3030ef488c1aa0985701cbd63d7d78a/7fc1e/Instana-zosconnectcalls.png 288w", "/instana-humio-hybrid-systemZ/static/a3030ef488c1aa0985701cbd63d7d78a/a5df1/Instana-zosconnectcalls.png 576w", "/instana-humio-hybrid-systemZ/static/a3030ef488c1aa0985701cbd63d7d78a/e5284/Instana-zosconnectcalls.png 850w"],
        "sizes": "(max-width: 850px) 100vw, 850px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`You should now be looking at the call overview for the z/OS Connect Service.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "33.68055555555555%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAYAAAAIy204AAAACXBIWXMAAAsTAAALEwEAmpwYAAABJUlEQVQoz22RS04kMRBE62RsWbDiDNyIkyAhAWIDNxhpDoCAXQvEdLXLdv5cD9ndID5jKZRpO50Z4ZiWXJl3C2nJLDkjar+gHeb/Rb9flkzOhVIqU0QgquRSPxtUkXFWVVFVPIK2rrTWfmD9FnvdZGOKIiK0CMJ9xI88eqEodmjsHvvYGmaGu4+9eQwyU0TD3JlzZVFnLsJOjF1Vyr/tGCRvbzR3VmA9MDURfN6OPQd0tVOfUCw4u3vl+HLDydULpzcvHF1sOP87A4FGI9o62MbIG1lsvNNYyRYj92hdsiFm3D8nrp8yN4+J28fE5UPiz6YMWZ8GmaHezTCKGlmUXa6kKnt0UzrDXry6QNqCFr6uIYmDLKDWOv7cYs9yThkRJaVluPwOGLMdrbADpPIAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana zosconnectcalloverview",
        "title": "Instana zosconnectcalloverview",
        "src": "/instana-humio-hybrid-systemZ/static/fd71950397e8e0ac5c1a286b1a49c2ce/3cbba/Instana-zosconnectcalloverview.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/fd71950397e8e0ac5c1a286b1a49c2ce/7fc1e/Instana-zosconnectcalloverview.png 288w", "/instana-humio-hybrid-systemZ/static/fd71950397e8e0ac5c1a286b1a49c2ce/a5df1/Instana-zosconnectcalloverview.png 576w", "/instana-humio-hybrid-systemZ/static/fd71950397e8e0ac5c1a286b1a49c2ce/3cbba/Instana-zosconnectcalloverview.png 1152w", "/instana-humio-hybrid-systemZ/static/fd71950397e8e0ac5c1a286b1a49c2ce/0b124/Instana-zosconnectcalloverview.png 1728w", "/instana-humio-hybrid-systemZ/static/fd71950397e8e0ac5c1a286b1a49c2ce/2b1a9/Instana-zosconnectcalloverview.png 1821w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`This display shows call counts, erroneous calls (if any), call latency and Endpoint Names referenced by the application.  In this example z/OS Connect is invoking an endpoint called catalog.
Click on catalog under Endpoint Name`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "18.75%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAECAYAAACOXx+WAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAp0lEQVQY03XOQW7DMAwFUd//mFkECeo4diSRFCVqithOiy66eNAAf0FNz2Vju97IWsnmx/uPx5pYtsSmlTUrl/vC/bEyP19cv46eUi6UdBBRtDa0+o+iFbFP205qQ6yi3nllIYmRs1DWjalYJXtg84ynRAyIiNNAvdF63zvG6dzHGJQivD9lRXARpvf1Yk4AfQx6j18RmHe8973/bOeuVimieOu0CL4BOlg30Fjn5w0AAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana inquire",
        "title": "Instana inquire",
        "src": "/instana-humio-hybrid-systemZ/static/45d47431bf6da808c2fe00fac979a935/3cbba/Instana-inquire.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/45d47431bf6da808c2fe00fac979a935/7fc1e/Instana-inquire.png 288w", "/instana-humio-hybrid-systemZ/static/45d47431bf6da808c2fe00fac979a935/a5df1/Instana-inquire.png 576w", "/instana-humio-hybrid-systemZ/static/45d47431bf6da808c2fe00fac979a935/3cbba/Instana-inquire.png 1152w", "/instana-humio-hybrid-systemZ/static/45d47431bf6da808c2fe00fac979a935/6d685/Instana-inquire.png 1596w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`You will see the display expand to show individual transaction executions and the latency time for each transaction on the right of the display.
Click on GET/inquireSingle`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "474px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "40.625%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAABYlAAAWJQFJUiTwAAABNUlEQVQoz4WPW27CMBBFvf/fdgVsox9pF1BVLVIRIBIqAiEmDyd+JY7tW8URKagfjHR8R3PH4zGhJYMQErXoUHEFWreBc9kECiZQthJlIyd9APk+Vnj5kfj4XCJOc+wOZ3ytE6z3J+xSiqxscWkkKJOgzWPIoWyxyjniQ4ZTwbDdH/G+XCM5UpRcgzKBnIlZH0G4VDDGwFgPoToI3UHqfoZLPdX/ocGFAlf3PjGDRVUz0EuBMZxzQbXWEFKF3Ht/zzDA4y9uPdKbAU3Lw9AxrLXBUGoa6LzHYC2sdcGz3sNNjRBRBBHHYfjojcsQpfv5JetcKF639DfnrF0H+/qG02KBNIrQd11Y4HqPWOOQqRqxyEN/ds4geAumDJKCI60EtnmDXd5gU2nkqw2S5ye0jN3+eU5/ARH7Za2QBJJEAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana inquirydetail",
        "title": "Instana inquirydetail",
        "src": "/instana-humio-hybrid-systemZ/static/b51d3caad7781747b60c47d0cf11d316/d8695/Instana-inquirydetail.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/b51d3caad7781747b60c47d0cf11d316/7fc1e/Instana-inquirydetail.png 288w", "/instana-humio-hybrid-systemZ/static/b51d3caad7781747b60c47d0cf11d316/d8695/Instana-inquirydetail.png 474w"],
        "sizes": "(max-width: 474px) 100vw, 474px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Scroll the display as you did earlier to see the Call detail
You should now see the detail for the z/OS Connect call.  This includes request path, API Name and Request ID, as shown on the right.  This also will show the call sequence in the middle.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "44.44444444444444%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAAAsTAAALEwEAmpwYAAABe0lEQVQoz1WS224UMRBE5///g2fygoggv8ITuyRLZmd8ad8vB9kzG8BSqdttd6mq7aW2Rmud1hr1H7QT/+W1EUJExLEpg4v5rNd5lnNm8d4jIqSUPgh6a5RaJ/42VFrvhBixIlgfJ0JM5FrJpZJSZhEf8fEg673PPJaKOD8v9A6llEneAXEOawUfEiFmYm1EbYjiSKWyaElon6bkoU67gA2ZGI9aOe1Mxa2jjWHf1VTmfGC7XLGvb8SUp8plKJIQSbmQS8GFOA9HQ8r5oz5Arxhj2fadTWl2rZFdUcoYTzsIU66MNey0zrTYz/0jb7Whfeb7NXPdLEYpxAeUNtwv1/lIVtxUvGx2RatXjL2T0k6MGiMa4w5YpwnBYoNw31bW6wXxHu/DJHCnuzHvEZfftxd+/fiEu32l3T9T1yfy+4GyPiG3L+i3Z8ztmbp+Q91/oiUQUpoPGFKeI4q5zLgMU0O+Np6YGof/0/Qj0ub8xk9QxqCMnQQPwhEf+APrJLpx0CT4xAAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana inquirecallstack",
        "title": "Instana inquirecallstack",
        "src": "/instana-humio-hybrid-systemZ/static/f9f1b47b7a5537d505d1020f33aeb8ab/3cbba/Instana-inquirecallstack.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/f9f1b47b7a5537d505d1020f33aeb8ab/7fc1e/Instana-inquirecallstack.png 288w", "/instana-humio-hybrid-systemZ/static/f9f1b47b7a5537d505d1020f33aeb8ab/a5df1/Instana-inquirecallstack.png 576w", "/instana-humio-hybrid-systemZ/static/f9f1b47b7a5537d505d1020f33aeb8ab/3cbba/Instana-inquirecallstack.png 1152w", "/instana-humio-hybrid-systemZ/static/f9f1b47b7a5537d505d1020f33aeb8ab/4fd0c/Instana-inquirecallstack.png 1515w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Click on CSMI`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "490px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "55.208333333333336%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAABYlAAAWJQFJUiTwAAABy0lEQVQoz52SXWsTQRSG9+faSnshvVMsFFREEFooIui1oPZGmlb7B+yFaEtTUStNstnsdzafuzszOzOPZJvG+gl64GGYeTnvnAOvI4QgiiLSNGVW1tqa/y1HSEkQhrXpVcO/AX/WHMy/T3O5wO86nYlUnE0mKClRSlFVCqUkVVWh58w0KQWissjqYsLa1Vq0sYxKw7CwNU43z3na6ZDECWEU03a7tNwunRldD88PcHs+cZIQjjTxxKCNQWlTGypt+RgYTnqGpm9wzEyY/akEeVHSzwVZIckKwahUZHlBf5pTSoWSgv60IJ0KkklZG18s/h3Hli5Db5tHzed4zfuEJ/foHd3BfX+X7rt1Mm+PKDlH+4+x/kOsv4kNNiHYqk8bbKGD7QWOyT9RnS/hfrmB+bzMuLlE73iF8Pg6w7MVpt5tgvYDqt4a+KvgrUJ7GXt+DVq/4miZwmAfsgaH7WekvR2y9kvG6RvEwQaj3VvErzcY7q8z3L1J+mKN4uQJjA+wWQM72MNkjQWOnsdGWXgVj3AHBUk8pF9C5+0R0eEHotOvdE9bJK2AcZghhV3EZoa5gqO1Bnt5tWB0HZ1pKRDz1xIYGZA/ZHHe9xPfAFeaO6MjlvAiAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana csmi",
        "title": "Instana csmi",
        "src": "/instana-humio-hybrid-systemZ/static/2a805e592086d26ced5035a88c8c1668/ac602/Instana-csmi.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/2a805e592086d26ced5035a88c8c1668/7fc1e/Instana-csmi.png 288w", "/instana-humio-hybrid-systemZ/static/2a805e592086d26ced5035a88c8c1668/ac602/Instana-csmi.png 490w"],
        "sizes": "(max-width: 490px) 100vw, 490px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`You should now be able to see the CICS task detail for the underlying CICS transaction invoked by z/OS Connect.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "42.01388888888889%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAAAsTAAALEwEAmpwYAAABXUlEQVQoz02RzW4cIRCE9/2fJofY8TmHXHJODs4lsjxaO9kZYPinB76I3lESpBLQQHVVcSmlkFKmtsbRu6Kf83H8j0NruRRCTIRcqE30Xa1N79xuK5eQEhMiwhhDL0jvxJSotTLHPJuEc8z67j2lNmLK5CY0mc0Gt3Xj4mLD5/ZXlYtZ9zkXZKo6Feq6D4x1bJthM06VJuuopXIMWCdhTJU9FZoIIodayVXIpWptdlcFqnDgnGMzBh8i3gfWb9/JPijhbV25TFtdc5uPRNG70M95Ekm7N/36XriuFmctPhVFmpabqDvN0Geh1E6qAxnQOiT5h3KAdPAVnu3gt/X4fae0u4uiTu5xqOWrfWG5PrPbn0h+paWFGBbSCWNf2eyCdQs0Q/BWc7Ru1wzn51RVOO6WD/eF/e2BcH0k/vhAf/8I7gnspxNPimEeEfsZZ39hzK6EPiZVOQnl6Fjr+AMfdWrSVjimnAAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana csmidetail",
        "title": "Instana csmidetail",
        "src": "/instana-humio-hybrid-systemZ/static/c51e5bdc69a7539d3652f79cf677de51/3cbba/Instana-csmidetail.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/c51e5bdc69a7539d3652f79cf677de51/7fc1e/Instana-csmidetail.png 288w", "/instana-humio-hybrid-systemZ/static/c51e5bdc69a7539d3652f79cf677de51/a5df1/Instana-csmidetail.png 576w", "/instana-humio-hybrid-systemZ/static/c51e5bdc69a7539d3652f79cf677de51/3cbba/Instana-csmidetail.png 1152w", "/instana-humio-hybrid-systemZ/static/c51e5bdc69a7539d3652f79cf677de51/f0009/Instana-csmidetail.png 1502w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`This display will show the CICS Region Name and the CICS Task Number for the transaction request.  Note that the application will also make a call to a VSAM file, similar to the other example application flow.`}</p>
    <h3>{`2-3: Problem Analysis Using IBM Instana for z/OS`}</h3>
    <p>{`IBM Instana for z/OS provides information that allows the user to identify and isolate transaction issues. This is whether the issue is at the http server tier, at another distributed tier, or at the z/OS, CICS, Db2, IMS, z/OS Connect or MQ on z/OS tier.
As shown in the prior section, Instana provides ongoing information on transaction performance/latency and breaks down that information by the various tiers of the application.  This section of the lab will outline how to view and analyze application performance.
A good place to begin with problem analysis using Instana for z/OS is the Overview display for zHybridApp. `}</p>
    <p>{`Click on the Applications icon on the left of the display
Click on the Name header and sort descending
Click on zHybridApp`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "704px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "52.43055555555556%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAABYlAAAWJQFJUiTwAAABqklEQVQoz5WSTU8TQRjH5+BRYtCDiUpMTKQQMRGFGi8CB/kA+v30bPwAmIjGBCiVk4YT6aEoSbds2S37OrOzM/szO6WNYA86ye/wPDPzPP/nRcwurXL7yQu299p4pwN6fZ+e53M6OOMsHKJ0SfEfiGv3FxEPlth+/4Fpp6oqrK0w1mKramRXFcZY57uKuPN8nY21TQ7eviNWin6tbHiOMQapCpI0Q+vSESeps6VUk2RcQdxaWafR3GB3t4VfaDr+gOMgJEoz93kYxaNAWc55nDiiJCXLJekUxPyr1zzcfMPHnX2XtVZmraU0hrJWAVhw9qQ0c3E/BTH7aJWbj5t83T9AyZzucZee5+F5HkUYojod4h/fR+X9wxEzC0+5sfiML61vzhHWkzWWpNvF39oiPDpCRpFTPQ1VFJOqasTdlZfMNdf4tNNyAYMgoNSaylr+1FQ/Hk94TG3neU5Zmsk2iOuNZWYWlvm810ZjiWVBoi0qCMjabZLDQ1S/P+rlRdAxdT9jqS/5hJhrIO7Nux7WAcMkJ5IlMs2If/0kOjlBheF4Kf/a0VybS/39DepS1ZtiLjsGAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana applications",
        "title": "Instana applications",
        "src": "/instana-humio-hybrid-systemZ/static/e78f4ddd4f50d0c899d3fd33713112cd/beb41/Instana-applications.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/e78f4ddd4f50d0c899d3fd33713112cd/7fc1e/Instana-applications.png 288w", "/instana-humio-hybrid-systemZ/static/e78f4ddd4f50d0c899d3fd33713112cd/a5df1/Instana-applications.png 576w", "/instana-humio-hybrid-systemZ/static/e78f4ddd4f50d0c899d3fd33713112cd/beb41/Instana-applications.png 704w"],
        "sizes": "(max-width: 704px) 100vw, 704px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`You should again be looking at the Summary display for zHybridApp you were looking at earlier.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "48.958333333333336%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABtklEQVQoz4WSy24UMRBF59NZZZUPYM8WSAR8QSSGiA0ogQV5gvJknt3u9tjlcvlE9owiZQNuXbnlKt+6dcuTs7sbzq9vufxzz/nNA9P5gmWIWDZEM+k/cMNI1zuG0bd9Mus77v8uuH+cczdb8mvd0YWAiCApoZr/iZqTVElJcW5g4v2Gukr9SgEzVJXBb1qymZFzJmdr/yEKvRsaSYvtYFbonWNiamClka4CHD/WygU/jq0NzRkrpV2uBaUqGUd0p75KOVsnbpzgB8dk7/Q9+6cH7J28Zf/nJ159P+DN5RGIEkLYEpk977VAEGmxSljPh5hI2bYtv7v4zMffXzm8+sKH62MOr6Yc3f1Aa5IIKVZETASNQowRH2IjrWqjJEKMzYI2FLaqX64C487D6l9VtQ5b8+uZ34Q2BN3F2oBypq+EnevpnGP0nlwMtdxM7nygD0LMhTEZ3+bCcoxtIEPLDyTRVrB6rAW62nJ9b8/YeWU5M/OJeTBWcYtBC7NReJgtyKpt2nn3dCyl1ljajExiiEhMSJQXWG0S65jpxVhHxasRkrJarVrLMUojtSRcLDe8PlkzvXU8AbX+AuJC9SnNAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana zhybridappdetail2",
        "title": "Instana zhybridappdetail2",
        "src": "/instana-humio-hybrid-systemZ/static/6a76131aade44fe3ce26076496c398bb/3cbba/Instana-zhybridappdetail2.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/6a76131aade44fe3ce26076496c398bb/7fc1e/Instana-zhybridappdetail2.png 288w", "/instana-humio-hybrid-systemZ/static/6a76131aade44fe3ce26076496c398bb/a5df1/Instana-zhybridappdetail2.png 576w", "/instana-humio-hybrid-systemZ/static/6a76131aade44fe3ce26076496c398bb/3cbba/Instana-zhybridappdetail2.png 1152w", "/instana-humio-hybrid-systemZ/static/6a76131aade44fe3ce26076496c398bb/0b124/Instana-zhybridappdetail2.png 1728w", "/instana-humio-hybrid-systemZ/static/6a76131aade44fe3ce26076496c398bb/65d9c/Instana-zhybridappdetail2.png 1836w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`The Summary display for zHybridApp shows an overview of call counts, erroneous call counts, processing time and latency time plotted over a time interval.  The time interval is customizable based on the options button on the top right of the display.
Note – it is recommended for this exercise to start with a time interval of One Hour
You should note the latency plot chart for zHybridApp shows an occasional increase in latency time for the application.  You may also notice an increase in Processing time in the same time interval.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "844px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "93.05555555555556%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAYAAACQjC21AAAACXBIWXMAABYlAAAWJQFJUiTwAAACU0lEQVQ4y5VUW47bMAz0kXuHomfoWfpd9HM/e4AC3TSNbL1lvTUFaTu73STYVgGhsURJHJKTKaeEEAJKKXhvjDF4DrXj83eHj08WX58jRslIuaC2hkkah+fTCbNW6L2ht4xaO2ppfMFbo+FKx6cngw/fFL78CMjBw1iPUiumnybC+YDzquDUgmROWMSK+aJRakHO9EBFjPF1rHcZtNYx0YHWGmJO6BzFRo1+9M3Wt+hSrogls09pna31jt477zPlxh+AMAalVd6gCzo7Hhd2jsD6CL06xtd9mvd08IUcTQeENWijbc5j3BSChrQePsfrhVefvvlQcJMPAdJ4/NYG52WBDSt8SpiVgXYeIWXMesOzcThLCSokrStaU4bxog3WGDGJWUJps1FyjgvAlfSBC8JtElbEmBjHlLCuW5S0731gTIGRz0QHrV+ZP+WE5lIP3Bm3PpgOtQXNG25cVfKj9T42/8k6j4XoGYtEFacD7ZX1f8S9o9aGKZeKzQoOHHNGTP9p+5mJEkk5IQvryjI8WuHG9p67a0SZIrTWQgiB868TzxchOMqtNQa3xNG47w1WymVRsFoh6wukXKBDg5CO20cphyATxCxgrTsa86HGSXFMmalmcIXHHs3YaY6/qA6u+LiTjqtSXmSVUWq/ld4ryql0+Ng4yhefN1o+ZCYuC8qeu/FAevQX5Z1/6MPSI7rUg6SYeZZc5ZXWtIFzjqu/YQ8pFYRYOJ+0TsqiPcLGWFbRNC+SP2gopVlO9KLetUnYWAvv/VWGdBGt82PGbD7GIqwRfwB9ps5IuFAy4gAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana 1hinterval",
        "title": "Instana 1hinterval",
        "src": "/instana-humio-hybrid-systemZ/static/92595ef6e6fdc6fe330c4f11c871594a/fc8f6/Instana-1hinterval.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/92595ef6e6fdc6fe330c4f11c871594a/7fc1e/Instana-1hinterval.png 288w", "/instana-humio-hybrid-systemZ/static/92595ef6e6fdc6fe330c4f11c871594a/a5df1/Instana-1hinterval.png 576w", "/instana-humio-hybrid-systemZ/static/92595ef6e6fdc6fe330c4f11c871594a/fc8f6/Instana-1hinterval.png 844w"],
        "sizes": "(max-width: 844px) 100vw, 844px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Position the cursor over the plot line for Latency
Note how you will see a flyover popup that shows the latency time and a percentile.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "900px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "37.84722222222222%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAABYlAAAWJQFJUiTwAAABa0lEQVQoz31RS07DMBTM7bgEF+MErJHYsWHDghUbFkiV2tA0jUnif+zEju1BdkGtisSTnp9sjcYz8ypCCISQyJXwf8V0Qhykw+3TgJvHAXfvCsHqRLnEuq60YoyDKoEQAhAcYghYfSwzf5FSQooRMcYT6X6Pw8srHrYG9xuLt8EBwafF+YyhlZAanWVovwjEcYOmafG5pej6AdpYTMbCWAvjPAJjoM/PCGG9Fv9rjlb5XLxDvR1x7Bm40lBmgpwM7OKg7YyW9CADRXPo4H6U+hBLh5hyFCnG4oZWwUf0SoA2HzBa/8ltWRx29R513aIdhpxTsX/VKc9C6H3AqCTeSAP2s5zL9Xi/4tgR1J8HUCMQ00lhSmdMOl9oNQoFwgV2vUDPRLHIlMbIBZSxxfrABcjI0HEGqlR5M4uDNLZgzbIkoSfYeaYV5bxQKyVh7Fy02XkGF7Ko8OsKxkVRmnVIpcuiLnE5Q6UnaD3Rb/UqaIGRsY5qAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana flyover",
        "title": "Instana flyover",
        "src": "/instana-humio-hybrid-systemZ/static/fc1cc21aa787a84464b2c9fbf702a23f/929af/Instana-flyover.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/fc1cc21aa787a84464b2c9fbf702a23f/7fc1e/Instana-flyover.png 288w", "/instana-humio-hybrid-systemZ/static/fc1cc21aa787a84464b2c9fbf702a23f/a5df1/Instana-flyover.png 576w", "/instana-humio-hybrid-systemZ/static/fc1cc21aa787a84464b2c9fbf702a23f/929af/Instana-flyover.png 900w"],
        "sizes": "(max-width: 900px) 100vw, 900px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Click on the plot chart line   (where the latency is high)
Click on ‘Zoom to time range’`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "850px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "39.93055555555555%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAABYlAAAWJQFJUiTwAAABXklEQVQoz4WSXWrdMBCFvd8uI0voCvrU12wheS630IYQ6MOFkJsbW7b1Z0mWZPkrUtIEkkIODCONRqNzDupSinjvySnxGfZ9f83f/zgufmguj56SEzElyr7TSW04nU6M89QaS45sWyHnre3fR0W9+PW35cu15NvdgncOqTQ5Z7qnJSFjpveSxWiifEDJgDgrwhqIMbbGquI90/+hyyFgDwdmpfFhxfmAsbYNKmVnyxvlpbme5+2ZeS6FVJWUQnmJWu/MzwPi1w1HMWKM4fzU0w+iSaisKpfiPSVGZutwMVCL9bHX2J9zG1hSIgJHIVBK8XjuGceJYRDYNRJub5mvr9isQzqPT+FN9v7Rgm6NETFr7qeZx2FAzJJJaU79wKQNSoxMWqP9yqA0o9Vo61jCivUBaSxuXdGLa5Z00yyRWrfpyhhiym1tnWt+VizONV//+Wjs0iTWr1KtqZJrT42/YDJq5x1v3TkAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana timezoom",
        "title": "Instana timezoom",
        "src": "/instana-humio-hybrid-systemZ/static/dd8cb29675fa2750878d0f9089dac286/e5284/Instana-timezoom.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/dd8cb29675fa2750878d0f9089dac286/7fc1e/Instana-timezoom.png 288w", "/instana-humio-hybrid-systemZ/static/dd8cb29675fa2750878d0f9089dac286/a5df1/Instana-timezoom.png 576w", "/instana-humio-hybrid-systemZ/static/dd8cb29675fa2750878d0f9089dac286/e5284/Instana-timezoom.png 850w"],
        "sizes": "(max-width: 850px) 100vw, 850px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`You should now be looking at the Summary display for the selected time range with the high latency issue.  Note how the time range for the display has changed in the upper right.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "48.958333333333336%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABpklEQVQoz22S2Y4TMRBF+/9/hz/giUeeWAWISTKBJO1Jd3urKtsH2Z1BQsLSVUm1Xt+q6fPhia8/jnz/+cyX45l3txmXhVIqYgX9D4ZfjTg73PyCuy9smydnYfp9d5x+XTmdrxwuNz64F+4xoaKIKmblH6gZViqmSl43ZOQZWXTEpp7UX+Pxah3NfIiDRa11sC11Rx+ybn7YCsPX2o6sylRKoaO3PG2Ft6c0JgYf8D5gpexNa6W2NmKr92OYjbrKJyccFqGaMp29YwkLYsJdMi4ZXhI5JnLOtNYGat1t/1GSjIiQ1cYgr5WghnaGT8sFlza2HHFxJWvChXUIbCNpRyuGmQ1/h9ju74y7dmpKEmGSrH+Lulav4ocQBosuRy+Yw76k/ND3dWF7sx09Nq3bNkROKY3FjO+1htsi96ik0lil8v6mXNfIsnn8thL6JWgZJHpdaQwJHkupvC5nwArXoFxiYc6VORW8wfOSOF9nWr+EfioxkmKkSQTLlH42Ocl+c/2OHlay4KKySGXTSrI6mC4hcbnNpJzJIqSUMRGO98ibbysfb5E/1ZsK4YTGOeIAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana latency",
        "title": "Instana latency",
        "src": "/instana-humio-hybrid-systemZ/static/fa961082b7edffde0383aa54859f91c8/3cbba/Instana-latency.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/fa961082b7edffde0383aa54859f91c8/7fc1e/Instana-latency.png 288w", "/instana-humio-hybrid-systemZ/static/fa961082b7edffde0383aa54859f91c8/a5df1/Instana-latency.png 576w", "/instana-humio-hybrid-systemZ/static/fa961082b7edffde0383aa54859f91c8/3cbba/Instana-latency.png 1152w", "/instana-humio-hybrid-systemZ/static/fa961082b7edffde0383aa54859f91c8/0b124/Instana-latency.png 1728w", "/instana-humio-hybrid-systemZ/static/fa961082b7edffde0383aa54859f91c8/71ce7/Instana-latency.png 1833w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Click on Analyze calls`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "752px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "19.791666666666668%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAECAYAAACOXx+WAAAACXBIWXMAABYlAAAWJQFJUiTwAAAA60lEQVQY02WOUUuDYBiF/Y9d13/o99RajKCMQRfNVl1EUGrCMnLGIIp0FemnfrJVS53zCa3d1IGHc3jPuXgVmU6IZUooYt7CqOFzllHMS/Ji/p9ywYfnk8UJBZD/2SlSTkjlhDhKiURCEEZNsVRVUy29am4zIZC6QWGYkBc/ZblonlCc9InDV4tTYXMeOBycXNBSj9jc67Gx26Olamx3j2nv9xvqvKX2aZ+ZrGgaq5bFmm2z7jjIrwzFnwpu4keG0mOUjLHde/SBiz4Y/rqLad9hXLsNdb60brkaPbATBHT8MR3Pp/v8wnuW8w2Sox76PlwO2QAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana latency analyze",
        "title": "Instana latency analyze",
        "src": "/instana-humio-hybrid-systemZ/static/fb4a509888ae16be82c6874c175b167f/cb78d/Instana-latency-analyze.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/fb4a509888ae16be82c6874c175b167f/7fc1e/Instana-latency-analyze.png 288w", "/instana-humio-hybrid-systemZ/static/fb4a509888ae16be82c6874c175b167f/a5df1/Instana-latency-analyze.png 576w", "/instana-humio-hybrid-systemZ/static/fb4a509888ae16be82c6874c175b167f/cb78d/Instana-latency-analyze.png 752w"],
        "sizes": "(max-width: 752px) 100vw, 752px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`You should now be in an Analytics display for zHybridApp.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "41.66666666666667%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAAAsTAAALEwEAmpwYAAABJ0lEQVQoz2VRXU8EMQjc///3fFAT9UETL27cu91+UAptx8Ct66lNJtACA0OnTAVcK1LKyJlApUBEodogqpBf9i8UIgLaOWqtmGJK0NZgxBawJLu33tFad9u//Vv0H/QdNshUmP2xivhUBvMNVmjkHrMmrR3WG2vbc65N6kHYroSJskumymBVFL0Sqyj+HlVF7wPoDUMZ0ILRjLCwj8uiuJ/PeJjPeF0TPhLh5RKxUvGJrHu92aX6/ioKbY5KG4jJCIsHqTASFZdkEg45XqjHx3AVz2URmLp1C0iZsIXomOxnrMgSQozujzFcjmPs6ANjAMwVMSZkaa6KWDxWuPp6JtqnYmac5k8sa0QkRsjlH+x9WQNO84JzJCxbwhIynt/ecff4hEtI+AIrUXE1OTRNxAAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana latency analysis",
        "title": "Instana latency analysis",
        "src": "/instana-humio-hybrid-systemZ/static/f9ea24e30b9875c4e97e0db6e0e52359/3cbba/Instana-latency-analysis.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/f9ea24e30b9875c4e97e0db6e0e52359/7fc1e/Instana-latency-analysis.png 288w", "/instana-humio-hybrid-systemZ/static/f9ea24e30b9875c4e97e0db6e0e52359/a5df1/Instana-latency-analysis.png 576w", "/instana-humio-hybrid-systemZ/static/f9ea24e30b9875c4e97e0db6e0e52359/3cbba/Instana-latency-analysis.png 1152w", "/instana-humio-hybrid-systemZ/static/f9ea24e30b9875c4e97e0db6e0e52359/0b124/Instana-latency-analysis.png 1728w", "/instana-humio-hybrid-systemZ/static/f9ea24e30b9875c4e97e0db6e0e52359/3e699/Instana-latency-analysis.png 1816w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`The bottom portion of the display by default shows Service Name listed by Call Count descending.  To focus on high latency, sort the display by latency.
`}<strong parentName="p">{`Click on the box to the right of ‘Select metrics’`}</strong></p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "814px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "24.65277777777778%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAFCAYAAABFA8wzAAAACXBIWXMAABYlAAAWJQFJUiTwAAABBElEQVQY04WQzU7DMACD+/7PhIQ4cOHAkUnANqZp2dKmaZLmPxkfWl8AS77YPtge+AchRCY1k3PZWEoh5kysjVzr5ocYSSnTemcI6REopNpIpRJzJeS6aaV11GI5ngVCKuSkcaWhlObw9Mztc89oVoScOAuJD5Fhtz+zO5w5XEak8Zx04GdyHC8jkw1cpgWhLMeLRNqI2H1xfHnl4+2d75Pgqh1CGW7a4UJmuErFdZzRdt2ajb4wuoQ2bmtrfEavkXFe8CmjxQ2zBiYXGGfD4jyLXXE+bguHSWkeXIyl9TuxdnyqrGug984cG3ItWOdprZPvv6Ta0XrBWEd5XPX4t1Rqa/wB9ul+TESvY5kAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana select metrics",
        "title": "Instana select metrics",
        "src": "/instana-humio-hybrid-systemZ/static/84b1052c74aebbf75f0719d3b31c5f4a/cf585/Instana-select-metrics.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/84b1052c74aebbf75f0719d3b31c5f4a/7fc1e/Instana-select-metrics.png 288w", "/instana-humio-hybrid-systemZ/static/84b1052c74aebbf75f0719d3b31c5f4a/a5df1/Instana-select-metrics.png 576w", "/instana-humio-hybrid-systemZ/static/84b1052c74aebbf75f0719d3b31c5f4a/cf585/Instana-select-metrics.png 814w"],
        "sizes": "(max-width: 814px) 100vw, 814px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`  `}<strong parentName="p">{`Click on Latency`}</strong></p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "602px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "35.416666666666664%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAYAAAAIy204AAAACXBIWXMAABYlAAAWJQFJUiTwAAABcElEQVQoz02Q64oTQRCF8/6voeKPfQtZhfhHEGRXEjbJzq17enr6Pvfkk2kRPFDUhapTVefgrEQZQecsNgZMdCiv6LzBeIeJns51SFmidYPzmt4pqk7QWYNPEWk11jm2beMwzjMxDTkx1lFWDUVZ431gXVeGYWCaJopGYKcp983ripAtSnU8Hg+MsdS1YFlXDvvQsswsy4IQEtkqqrqhVYrH4840jmz8RXp+Zqwq/sdO+A/3+53DvtH6SO8ThVC8Ny1FoyiFwsYBt94ZTmeuHz5y/fqNkAbGaSbEhGhV9iEknAu5ni/UNuCHmbrt+XW68HK+InqHjSPNp89cnp44/T7T9BbV9cQ0YpzP8qhOcysqbrcyS3ZQNhBjyue2qssvN0LS6Z5tnnk/HmnDgJ+3/IWJE7L32fowsM/bNOXYpZGDNAFtLEKqTLaT7oLvVguJm1dqHai14/vPV74cf3B6F7xVLYXseb0UNNrxVgq0S/wB0t0RqClCAD4AAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana latency metric",
        "title": "Instana latency metric",
        "src": "/instana-humio-hybrid-systemZ/static/8f83015c3d842886119ad16adf54b245/31129/Instana-latency-metric.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/8f83015c3d842886119ad16adf54b245/7fc1e/Instana-latency-metric.png 288w", "/instana-humio-hybrid-systemZ/static/8f83015c3d842886119ad16adf54b245/a5df1/Instana-latency-metric.png 576w", "/instana-humio-hybrid-systemZ/static/8f83015c3d842886119ad16adf54b245/31129/Instana-latency-metric.png 602w"],
        "sizes": "(max-width: 602px) 100vw, 602px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`You should now see a display listing Service Names for zHybridApp sorted by latency time in a descending order.
`}<strong parentName="p">{`Click on the line with the highest latency time`}</strong></p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "804px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "15.625%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAADCAYAAACTWi8uAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAn0lEQVQI102PSY7DMAwE/f+P5TrzgQBzCexEGyXLWqMKpEMwBIjmpQrNjX8zxlhZHg/avq/biud+/8NawYkn5YIxjpcyWCeEM2KsQ2mLNo4tpcQZL66U6b3TxkAkcPz8Ircb2XtciAuc21on58J5xq9w8nE6rsSmteF4Kp4vRc6Z2t9IhdDeyL5TSyV08DEvaD5R+iCVitJmSWqti52FPqtJ51niQ/zpAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana highest latency",
        "title": "Instana highest latency",
        "src": "/instana-humio-hybrid-systemZ/static/dded067b9e1e146efa42e03d78d9ac14/7d5b6/Instana-highest-latency.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/dded067b9e1e146efa42e03d78d9ac14/7fc1e/Instana-highest-latency.png 288w", "/instana-humio-hybrid-systemZ/static/dded067b9e1e146efa42e03d78d9ac14/a5df1/Instana-highest-latency.png 576w", "/instana-humio-hybrid-systemZ/static/dded067b9e1e146efa42e03d78d9ac14/7d5b6/Instana-highest-latency.png 804w"],
        "sizes": "(max-width: 804px) 100vw, 804px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`You should now see a listing of transactions that employ this Service for the time interval in question.  If you look to the right you should see some transactions with high latency time.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "19.444444444444443%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAECAYAAACOXx+WAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAp0lEQVQY002P2xLDIAhE8/9f2jRtYzWggLidYG8PZxB23IVl2zPywaCmEzFQFVD7oF8KNzyeBYUFpSrWR8LltmPPBy73hPWesGSqSIXmJ64o1w3c9A/BwQ0sGkEzfIZVsdDSwUjrBqKKRVRDfFaNgRHBB+DucB/o7hHW3/0YI+qpn29VRc4FlDMqn4Y2NzlPqNrDrHcPg6A7WAzWf/1/VTMQMZoqRA0vb+A30QAHtAgAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana latency report",
        "title": "Instana latency report",
        "src": "/instana-humio-hybrid-systemZ/static/431479e2cb5f25697ccfe82a7dcc1fe7/3cbba/Instana-latency-report.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/431479e2cb5f25697ccfe82a7dcc1fe7/7fc1e/Instana-latency-report.png 288w", "/instana-humio-hybrid-systemZ/static/431479e2cb5f25697ccfe82a7dcc1fe7/a5df1/Instana-latency-report.png 576w", "/instana-humio-hybrid-systemZ/static/431479e2cb5f25697ccfe82a7dcc1fe7/3cbba/Instana-latency-report.png 1152w", "/instana-humio-hybrid-systemZ/static/431479e2cb5f25697ccfe82a7dcc1fe7/dea79/Instana-latency-report.png 1576w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Click on one of the high latency calls
You should now be looking at detailed information for the chosen call, including overall latency time and the various subcalls.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "58.68055555555556%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAAAsTAAALEwEAmpwYAAAByUlEQVQoz3VTTW8UMQydX40ENw7c+DMIDogLEv8AAeUAohRKq+1qd2YniRM7Th6yZ6ZsERye7Dwrjj9eBpaKwoJc2K3BOKnqlqsu/maNu48LKBdMpxlEGTkXDMfxhMM4YZxmhEgIMXny7eI5tscecFI96VbQEBI5YUEjs1XLDDJ/BW28VMwxISUCr11tj4s/IBgiEVrvoFKQKKNq8yq1tSVZLuiAd8ApQErGcRxhhVjyUtjvtNZQq2IIMUKE0Zo6em9QrW6bKnpTP9eS8O464v31EWE8Yk6EQyDMZO3+GcVg7QSylhSlAln6mV18koYiDbcE/Ppxg2m3Q6CMKWbMqXjSre3h6qB49kbw9LXg8ct/48krwaMXjOdvO24vbzDf7UBcfY6FGartXgEDxYSrzxf4fvEJl/+Bxb59/ICfX78g7PeYx3FZDmXs7vaYQ3TfE3JhtBLQOQKVHkL/PmdwrV6VLc7HZSrZNm1LoZwRE/lGWwe0w61BtEPbwtXWnVvkUnz7NrtYBCGz69ErTKX6PEwm2+pjZoT1B9hZVT2RxU281t6i1zOseh1CFowxg1hQVX1TJyrOmYDrOnCLGazdZD+DxRNsMOkY9xtp05xPooUs+gAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana latencystack",
        "title": "Instana latencystack",
        "src": "/instana-humio-hybrid-systemZ/static/31335eca29984aabe14a95c9489b5acc/3cbba/Instana-latencystack.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/31335eca29984aabe14a95c9489b5acc/7fc1e/Instana-latencystack.png 288w", "/instana-humio-hybrid-systemZ/static/31335eca29984aabe14a95c9489b5acc/a5df1/Instana-latencystack.png 576w", "/instana-humio-hybrid-systemZ/static/31335eca29984aabe14a95c9489b5acc/3cbba/Instana-latencystack.png 1152w", "/instana-humio-hybrid-systemZ/static/31335eca29984aabe14a95c9489b5acc/8b438/Instana-latencystack.png 1525w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Scroll the display down
You should now be looking at the subcall detail for the selected transaction.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1012px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "82.6388888888889%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAARCAYAAADdRIy+AAAACXBIWXMAAAsTAAALEwEAmpwYAAACSklEQVQ4y4WUS2/UMBCA8///AQipHJHg0HJBIE5ckLiUUwWipct2S0s3iZM48WP8+JCzu7TALoz0yXFmPB7PeFy1XU+rOtZ1y13dUDeKXo90/YDqB7wEJMRflPlhItW6UfxYt/TjhJ4sxjqs8zPl2zhhcvLr378cOi9Ug/G0g0WNFm3uF0gIs0OlDW3RjRPdoJGi94KXB2znxaYqu5bIRhdIKRFjIsRETGneUVs/z61184KU8myzjxJAFcRTkJjIOf9GMbISSDnPETjvKfKnXaHYTNZSld13krmXYrQbQ4xzxPtkZ1fEFIdOZJOXkrdt7nY8zOe/itEaQRnZOJymCe/tfYy5HH0DHCKToiDeIM7w6Ezz+GwkeEelfER7EAEXQB6cewqgLHTuMEU/TJEYM8Y5qn5ccbl8w83lK+6Wr6lXbxnaU9Dvubv9wNflRxZXpwe5vDrlx80ppv+6uTbJnPP96ik350fcfjmiPn/C+uqYVD+jXb1gtTjh++KY68XJXlaLlzTL5/jmHY3qqUrxpgyL3lP3gcHBGMAnWI/wrYZlA8t6P0V/p0onxbmFqxDCXIDBW2rVobVgjCflyGSFwQiTj4zub6bt6GTjo1GKKqZtFUJg6Du06jBWcCGRrSaPDRgFpt2PVXjdzVdrE6EX3MUFt9cr1npEvMOnuNnDGYLRJDftRyyhbxk+fyLmTFsi9JMhaI0D2kHTD4ZRB0rk5TmSbSflA5Te3t20plVUEuPmqqaEiNCPBmOE0cn8OJQcx9J6/6E8LKrr+QmxkCKPthlXmgAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana latency stack drilld",
        "title": "Instana latency stack drilld",
        "src": "/instana-humio-hybrid-systemZ/static/ba598c1f168ea89bf6200722a11de919/83283/Instana-latency-stack-drilld.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/ba598c1f168ea89bf6200722a11de919/7fc1e/Instana-latency-stack-drilld.png 288w", "/instana-humio-hybrid-systemZ/static/ba598c1f168ea89bf6200722a11de919/a5df1/Instana-latency-stack-drilld.png 576w", "/instana-humio-hybrid-systemZ/static/ba598c1f168ea89bf6200722a11de919/83283/Instana-latency-stack-drilld.png 1012w"],
        "sizes": "(max-width: 1012px) 100vw, 1012px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Notice that in the example transaction the vast majority of latency time is in the database, in this example a Db2 subsystem on z/OS called DSNA.  From here you can determine that the cause of the latency is an issue within the database.`}</p>
    <h3>{`2-4: Understanding Dependencies Using IBM Instana for z/OS`}</h3>
    <p>{`IBM Instana for z/OS provides information that shows the interrelationships of the Services that compose an application, such as zHybridApp.  This section will demonstrate an example.
`}<strong parentName="p">{`Click on the Applications icon on the left of the display`}</strong>{`
`}<strong parentName="p">{`Click on the Name header and sort descending`}</strong>{`
`}<strong parentName="p">{`Click on zHybridApp`}</strong></p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "704px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "52.43055555555556%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAABYlAAAWJQFJUiTwAAABqklEQVQoz5WSTU8TQRjH5+BRYtCDiUpMTKQQMRGFGi8CB/kA+v30bPwAmIjGBCiVk4YT6aEoSbds2S37OrOzM/szO6WNYA86ye/wPDPzPP/nRcwurXL7yQu299p4pwN6fZ+e53M6OOMsHKJ0SfEfiGv3FxEPlth+/4Fpp6oqrK0w1mKramRXFcZY57uKuPN8nY21TQ7eviNWin6tbHiOMQapCpI0Q+vSESeps6VUk2RcQdxaWafR3GB3t4VfaDr+gOMgJEoz93kYxaNAWc55nDiiJCXLJekUxPyr1zzcfMPHnX2XtVZmraU0hrJWAVhw9qQ0c3E/BTH7aJWbj5t83T9AyZzucZee5+F5HkUYojod4h/fR+X9wxEzC0+5sfiML61vzhHWkzWWpNvF39oiPDpCRpFTPQ1VFJOqasTdlZfMNdf4tNNyAYMgoNSaylr+1FQ/Hk94TG3neU5Zmsk2iOuNZWYWlvm810ZjiWVBoi0qCMjabZLDQ1S/P+rlRdAxdT9jqS/5hJhrIO7Nux7WAcMkJ5IlMs2If/0kOjlBheF4Kf/a0VybS/39DepS1ZtiLjsGAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana zhybridapp2",
        "title": "Instana zhybridapp2",
        "src": "/instana-humio-hybrid-systemZ/static/e78f4ddd4f50d0c899d3fd33713112cd/beb41/Instana-zhybridapp2.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/e78f4ddd4f50d0c899d3fd33713112cd/7fc1e/Instana-zhybridapp2.png 288w", "/instana-humio-hybrid-systemZ/static/e78f4ddd4f50d0c899d3fd33713112cd/a5df1/Instana-zhybridapp2.png 576w", "/instana-humio-hybrid-systemZ/static/e78f4ddd4f50d0c899d3fd33713112cd/beb41/Instana-zhybridapp2.png 704w"],
        "sizes": "(max-width: 704px) 100vw, 704px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`You should again be looking at the Summary display for zHybridApp you were looking at earlier.
`}<strong parentName="p">{`Verify that your time range in the upper right corner is for the Last Hour`}</strong>{`
You should now be in the Summary display for zHybridApp.
`}<strong parentName="p">{`Click on the Dependencies tab`}</strong></p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "718px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "28.819444444444443%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAGCAYAAADDl76dAAAACXBIWXMAABYlAAAWJQFJUiTwAAABVUlEQVQY01WQvW7UUBCF/UpQ81K8ApCAKCIhhQAFqQjaCgkKCiii/EG/NKkQ2WhN1snaXtt3Zq7vvfshX2gY6dOMdGaORqe4WiwpyxWL65JfV9f0g7DdQkyJGBNp6mn7PzGx/QfTToj4MTCGSHHbtVRtTdU23FR33K5bms1A03Y0zqg7R9P21Ju/NBODsBLltxNKJ6zVslk2PPz5hdnihI/L77z98Jmn++/YefWeR69n7O3u8/LJC3YPjnh2cMTzNzN29g55/Okr9y/OeXByyr3jYx7O5/lT9YFCgkdGw8KIqiE20ld3rM7OKS++4doNTj1OLDNFMphn7T2NeVo/0oeQY5hiKvrekWJC1Fita2oz5PKSav6DCCTAOWFwkvMMIdIPDhNlKnWCGxwhRrwfKZwIZkYrwrLruOk6JEYsJkw1ayKaTadZVZlunCjmPaKade991v8AnTG91a6gf+0AAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana zhybrid dependencies",
        "title": "Instana zhybrid dependencies",
        "src": "/instana-humio-hybrid-systemZ/static/56c2b15262ad43c563e792b0c7b553f9/70c24/Instana-zhybrid-dependencies.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/56c2b15262ad43c563e792b0c7b553f9/7fc1e/Instana-zhybrid-dependencies.png 288w", "/instana-humio-hybrid-systemZ/static/56c2b15262ad43c563e792b0c7b553f9/a5df1/Instana-zhybrid-dependencies.png 576w", "/instana-humio-hybrid-systemZ/static/56c2b15262ad43c563e792b0c7b553f9/70c24/Instana-zhybrid-dependencies.png 718w"],
        "sizes": "(max-width: 718px) 100vw, 718px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`You should now be looking at a Dependencies view, similar to the following.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "50.34722222222222%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABN0lEQVQoz5VS7U6DQBDk/Z/IP76AMY3VNiUUW5TiR5XaIhz3sXdj9uBIi1XjJJNdLruzs3dEaVlgtl5jlmRYLDNM1xtcbrc4SAUiC2UI+idqA00WbSOwf3lFKxWiSglsyxLv5QfK3QFv+wqbuoZQClprGENemIhGtENkkFK+NmpaDRICIMIxnHOw1vr4GxlJuoJUCtY5RLySF+hFXJ//BdYKgo+bJ2hjfB5JpQdH/yVP5jXn8RLVZ90J8lpBcBxD/t2d66/EwRBhucpQN6ITPNc8zo/JBuzofuN0BSHaTvBcM4MnLpL77gVZpCcjCIbveZygEa2/e+/QGAMpVVfcF7VSIi+eh7MwrBHC/yrHw7O88K88rPyQF5jO4xPB3f6A65u7kzNuuprcegPBKWMynWFX1bjIFb4AG6YOn1na2IoAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana dependency graph",
        "title": "Instana dependency graph",
        "src": "/instana-humio-hybrid-systemZ/static/c83cbc067e88f3276ff20e34e29c20db/3cbba/Instana-dependency-graph.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/c83cbc067e88f3276ff20e34e29c20db/7fc1e/Instana-dependency-graph.png 288w", "/instana-humio-hybrid-systemZ/static/c83cbc067e88f3276ff20e34e29c20db/a5df1/Instana-dependency-graph.png 576w", "/instana-humio-hybrid-systemZ/static/c83cbc067e88f3276ff20e34e29c20db/3cbba/Instana-dependency-graph.png 1152w", "/instana-humio-hybrid-systemZ/static/c83cbc067e88f3276ff20e34e29c20db/0b124/Instana-dependency-graph.png 1728w", "/instana-humio-hybrid-systemZ/static/c83cbc067e88f3276ff20e34e29c20db/9d3b4/Instana-dependency-graph.png 1770w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`The Dependencies view shows the interrelationships of the Services that compose an application, such as zHybridApp in this example.  From here you may drill down to see more information on specific component flows of the zHybridApp.`}<br parentName="p"></br>{`
`}{`For example you may drill down on the z/OS Connect portion of the application.
`}<strong parentName="p">{`Click on zceebill in the graphic`}</strong>{`
`}<strong parentName="p">{`Click on ‘Go to flow’`}</strong></p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "528px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "41.66666666666667%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAABYlAAAWJQFJUiTwAAABPElEQVQoz41RTUsDQQzdX+3NQwUP3rz0T/QfCD1I8aB4WZGCFC8q3dIPd7fbzFfm48lk2yJVwUAmM5PwkpdXICVEAJYZjhnGOhhrwd4jhPBfjzFGpJTKIhgDPZkghgD2AUopOOegtAFzD8rM8IcGvzTy3kdrLQCURQKwGg6hxmOIhQBSGk/TGbQ2aDtC03bY1A3Wnw22SuPUUkrRGNMD5nO7XMIsFngon3EzvpWiTHtP4xjzeqA14D1S/jsBFMpCZZ85O7/ExdW13N8+KpBS/YRNC3IMV1VYDAaYj0bgrjuACSAR5b33lHO3mBLK6Qvu7h+l0Dp3nOzgzjHq1Uqm//6fFckTKmPLQqhk2kSYzl7xPq9EjOW6hjYG2x2Jb+pW4h8morQ76nconfaZrPKpa/3tTfQjT0RRaxGr/AIuXGhTmM7VYgAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana goflow",
        "title": "Instana goflow",
        "src": "/instana-humio-hybrid-systemZ/static/45b8b3e67c52e50fea4f041c30cf1656/3d774/Instana-goflow.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/45b8b3e67c52e50fea4f041c30cf1656/7fc1e/Instana-goflow.png 288w", "/instana-humio-hybrid-systemZ/static/45b8b3e67c52e50fea4f041c30cf1656/3d774/Instana-goflow.png 528w"],
        "sizes": "(max-width: 528px) 100vw, 528px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`You should now be looking at another graphic view that focuses on the flow of a portion of the zHybridApp, in this example the z/OS Connect portion.  Note that the call orginates from a request coming from zapm2-nginx.  The API call then goes to a z/OS Connect task named zceebill. z/OS Connect then issues a transaction request to a CICS Region, CICSAOR1.  CICSAOR1 will process the transaction and send back the requested information.
Note that in the display there may be a green + sign next to CICSAOR1.
`}<strong parentName="p">{`Click on the Green + sign`}</strong></p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "30.555555555555554%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAGCAYAAADDl76dAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA2UlEQVQY05WP7W6DMAxFef9n2u89wbSVtbQDqSotHwMCgcRJTkXQtO3HpM7Ska6vrGs7ObUlx+uF9FDwkp543Re8ZTnPt4qjGnHiMFYeJjnrho+6ZLfP2WUF71lBmp95Kq+k/QA+IM49TCJGsFaAwHcFCBve+3+RjFoTgieEn4Fb/G/n7wrWEto26sRYG4U4z7RYRBxuPV8kLtEiNLNlEod2Lvarv1hhNjbOenHc6hpZL/zashhD2w189irSDyr6al4oe0WlRqphpB2nzZ80TTfQ9SrSTDp+dAczWdNBonTwAgAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana cicsaor1",
        "title": "Instana cicsaor1",
        "src": "/instana-humio-hybrid-systemZ/static/3643beff192316bcc33f644b49a11b63/3cbba/Instana-cicsaor1.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/3643beff192316bcc33f644b49a11b63/7fc1e/Instana-cicsaor1.png 288w", "/instana-humio-hybrid-systemZ/static/3643beff192316bcc33f644b49a11b63/a5df1/Instana-cicsaor1.png 576w", "/instana-humio-hybrid-systemZ/static/3643beff192316bcc33f644b49a11b63/3cbba/Instana-cicsaor1.png 1152w", "/instana-humio-hybrid-systemZ/static/3643beff192316bcc33f644b49a11b63/1fc4e/Instana-cicsaor1.png 1406w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`You should now be looking at additional information on the application flow.  In the example below you see an additional icon that shows ‘Unspecified’.  Unspecified is a reference to a VSAM file access by CICS.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "23.61111111111111%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAFCAYAAABFA8wzAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAsUlEQVQY042QW2rDQAxFvf99dQWpP0ra0uLExHbGjxlNQuORTohj90ENreDA5XIlIWUv+5LHp1fy7Tv58xsPVU0RI2lMfFzGP7nMuSARiSey0jmKsqYoK3aHho1rqU5nTJUxJVLS/6F3Msz4VWbYguqXNkNVP/meWbzs3v9zqJqRDNJNz9jK4jVvGtiHiOs9gxd8kCnYhMhhEI5BaCVOXueFbgj0PuAlTpe4IdDO3u2PV59FhoI2VODSAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana vsam cics",
        "title": "Instana vsam cics",
        "src": "/instana-humio-hybrid-systemZ/static/c1d72fdeaef7a7ddc398fa48413f976e/3cbba/Instana-vsam-cics.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/c1d72fdeaef7a7ddc398fa48413f976e/7fc1e/Instana-vsam-cics.png 288w", "/instana-humio-hybrid-systemZ/static/c1d72fdeaef7a7ddc398fa48413f976e/a5df1/Instana-vsam-cics.png 576w", "/instana-humio-hybrid-systemZ/static/c1d72fdeaef7a7ddc398fa48413f976e/3cbba/Instana-vsam-cics.png 1152w", "/instana-humio-hybrid-systemZ/static/c1d72fdeaef7a7ddc398fa48413f976e/0b124/Instana-vsam-cics.png 1728w", "/instana-humio-hybrid-systemZ/static/c1d72fdeaef7a7ddc398fa48413f976e/1cf17/Instana-vsam-cics.png 1762w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`Note that each icon shows call counts, latency time and error percentage for the selected application flow.
`}<strong parentName="p">{`Click on the icon to the left to see animated flows.`}</strong></p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "17.013888888888886%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAADCAYAAACTWi8uAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAZ0lEQVQI122LQQ7EIAwD+f9b98KmBGchTNVDK1GtpTl4ZJdWK27GnMkY4yHXIjN33u7PpvjXWBG8kxIJrJvrLG2bNSdkbq7c9XDRuugS8RuoNT5Hp/bAJDQu51jrSEFXMCSaO+Z63Alk0ew68Qt1kwAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana animated flow",
        "title": "Instana animated flow",
        "src": "/instana-humio-hybrid-systemZ/static/4b0644c1b76814b1ce39f0731177cad7/3cbba/Instana-animated-flow.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/4b0644c1b76814b1ce39f0731177cad7/7fc1e/Instana-animated-flow.png 288w", "/instana-humio-hybrid-systemZ/static/4b0644c1b76814b1ce39f0731177cad7/a5df1/Instana-animated-flow.png 576w", "/instana-humio-hybrid-systemZ/static/4b0644c1b76814b1ce39f0731177cad7/3cbba/Instana-animated-flow.png 1152w", "/instana-humio-hybrid-systemZ/static/4b0644c1b76814b1ce39f0731177cad7/87a09/Instana-animated-flow.png 1717w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`From the dependencies display you may want to drill down to see call detail for the application flow.
`}<strong parentName="p">{`Click on ‘Analyze calls’`}</strong></p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "768px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "19.444444444444443%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAECAYAAACOXx+WAAAACXBIWXMAABYlAAAWJQFJUiTwAAABCUlEQVQY0x2KyU7CYAAG+5gm3n0I7149Ge+oGA+scSlLEYyCgsYQbQLRwAWNdN9oKX9px5S5fMl8I1muj245mI5LFG9YRTG262E5Lrpps9QN7EBg+WuWmoFpOdhO/nsE0ZoYCB2XUNMRGUiBG+FaPrbhkaYZOUII4jjG83w8PyAFkgzCMEJsNogkYbuKdi1hBN0e+AEizZDkvzc62piu8UHjaUSh1OS80qJQblKsK1zWFS4quWtSrCmcVdtclVucjFX21U8OZJm9ao3Tn19ItkiPmsrQmPJqftF/V7npPHN7/0K93edaGSB3hzQeRjuX711vSEMZcDn95nAy4Xg+52g2o7RYkG5T/gGLMRv61Qwu0wAAAABJRU5ErkJggg==')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana dependency analyze",
        "title": "Instana dependency analyze",
        "src": "/instana-humio-hybrid-systemZ/static/1f5f2fca50f0cb191489d917d55e69e0/d1b73/Instana-dependency-analyze.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/1f5f2fca50f0cb191489d917d55e69e0/7fc1e/Instana-dependency-analyze.png 288w", "/instana-humio-hybrid-systemZ/static/1f5f2fca50f0cb191489d917d55e69e0/a5df1/Instana-dependency-analyze.png 576w", "/instana-humio-hybrid-systemZ/static/1f5f2fca50f0cb191489d917d55e69e0/d1b73/Instana-dependency-analyze.png 768w"],
        "sizes": "(max-width: 768px) 100vw, 768px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`You are now looking at the Analytics display.  Note on this display you see call counts and latency information for the transaction requests.`}<br parentName="p"></br>{`
`}{`Note that in the Groups section of the display you will see one endpoint name, in this example it is catalog.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "24.305555555555557%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAFCAYAAABFA8wzAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA10lEQVQY02WPW0oDQRBFZ1f++ZHluLMgAXUD4jpiPgVHGIgz/aruqjrSMyFGLDjcvkW9egAHr0ADFDB6qOqKuV/xrmaYKly83+bNGPbHwOEUeHzvGtkfI68fmVIKIvKnacWMmAupGWpOVafaNrAfMNwdPtm9jNw/jeyeR7p/eJvQdaPTtBfeonyXxpQasyjn0r2yiCJqDONS+ApyZVyEKQq5CEUqpf4itSFdpa7Xz0sgpkzKmTlEUsoMtWS28Avb+99X3QkhrgNLM7I0ziFRayXERExpXfID3zWAL5w6CGEAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana endpoint",
        "title": "Instana endpoint",
        "src": "/instana-humio-hybrid-systemZ/static/35adb0012fdeaf175a40c82d1e2fab15/3cbba/Instana-endpoint.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/35adb0012fdeaf175a40c82d1e2fab15/7fc1e/Instana-endpoint.png 288w", "/instana-humio-hybrid-systemZ/static/35adb0012fdeaf175a40c82d1e2fab15/a5df1/Instana-endpoint.png 576w", "/instana-humio-hybrid-systemZ/static/35adb0012fdeaf175a40c82d1e2fab15/3cbba/Instana-endpoint.png 1152w", "/instana-humio-hybrid-systemZ/static/35adb0012fdeaf175a40c82d1e2fab15/5227e/Instana-endpoint.png 1588w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p><strong parentName="p">{`Click on catalog in the Endpoint name section to see calls`}</strong></p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "450px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "43.05555555555555%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAABYlAAAWJQFJUiTwAAABMUlEQVQoz4WS3U7CMBiGd8kccQ8cwwVwE3IqqImiiTGTExItLNPBtm4rSDbo32vWbaRj/nzJm6b5/p/WQW1aayilzNncfzM75jLekVKaQn8ldFQ5oaXsxDoZpXBfXTw8PmF2MwPx/H8nRLnJDwOYCcsL5xx5XoCxDMXxVIZAGQTV2eBQ5TblVHXycTLBwXWrHrLC5XAhAK1MkcaEkChR2DLFaz+fzxEMBliOx2A0MU2FECbO0UqC5hJBrnEqcmzD0CQxtkeUMCQZQ5ztsNlG2D+/IB0OsRyNEBBybtBaGVC43xS4+pBIwwDX06lxUJqAkDV8/xO7rwOyfh9vvR68xQLcZnnBurWysl4sDCOQ9xXWno80TrC6u0UcRVVWzfLM15L5NqKWzaz1jSwJzjt8bX0Dy8K5HEF4WBoAAAAASUVORK5CYII=')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "Instana endpoint calls",
        "title": "Instana endpoint calls",
        "src": "/instana-humio-hybrid-systemZ/static/3409443c087db372b1af8f3c2db1b330/532bf/Instana-endpoint-calls.png",
        "srcSet": ["/instana-humio-hybrid-systemZ/static/3409443c087db372b1af8f3c2db1b330/7fc1e/Instana-endpoint-calls.png 288w", "/instana-humio-hybrid-systemZ/static/3409443c087db372b1af8f3c2db1b330/532bf/Instana-endpoint-calls.png 450w"],
        "sizes": "(max-width: 450px) 100vw, 450px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy",
        "decoding": "async"
      }}></img>{`
    `}</span>
    <p>{`You should now see a listing of the individual transaction calls to the catalog API.
You may click on a selected call to see more detail, as has been demonstrated in prior sections of this document.
`}<strong parentName="p">{`Thank you!  This concludes the Instana for z/OS portion of the lab exercise.`}</strong></p>
    <h2>{`2-5: Summary`}</h2>
    <p>{`In this exercise you have explored some of capabillities of Instana to extend observability into the legacy mainframe applications.  You used Instana to get an understanding of the dependencies in a hybrid application making use of some mainframe backend. Using the Analysis you found the root cause of a problem in this hybrid application context.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      